import React, {
  useState,
  useEffect,
  createContext,
  useContext,
  useMemo
} from 'react'
import { useSelector } from 'react-redux'
import { ProSidebarProvider } from 'react-pro-sidebar'
import FuturisticRealEstateSidebar from './MyProSidebar'

const SidebarContext = createContext(null)
const ACTIVE_SOCIETY_KEY = 'activeSociety'

// Background gradients for each active society
const gradientBackgrounds = [
  // "bg-gradient-to-br from-slate-800 via-slate-900 to-slate-800",
  'bg-gradient-to-br from-slate-900/95 via-slate-950/95 to-slate-900/95',
  'bg-gradient-to-br from-slate-500 via-slate-600 to-slate-500',
  'bg-gradient-to-br from-slate-800/95 via-slate-900/95 to-slate-800/95',
  'bg-gradient-to-br from-slate-800/80 via-slate-900/80 to-slate-800/80',
  'bg-gradient-to-br from-white via-gray-50 to-white'
]

const themeColors = [
  {
    tailwind: {
      // User management
      text: 'text-teal-400',
      text1: 'text-teal-400/60',
      text2: 'text-teal-300/50',
      text3: 'text-teal-600',
      text4: 'text-teal-300/70',
      text5: 'bg-gradient-to-r from-teal-500 to-cyan-500',
      text6: 'bg-gradient-to-r from-teal-300 to-cyan-400',
      text7: 'text-teal-300/30',
      text8: 'bg-gradient-to-r from-teal-400 to-teal-600',
      text9: 'text-teal-300',
      text10: 'text-teal-500',
      text11: 'text-teal-300/80',
      text12: 'text-teal-400/70',
      text13: 'text-white',
      text14: 'text-white/80',
      text15: 'text-cyan-400',
      text16: 'text-emerald-400',
      text17: 'text-white/70',
      text18: 'text-slate-500',
      text19: 'text-gray-400',
      text20: 'text-teal-300/60',
      text21: 'text-teal-300/40',
      text22: 'text-teal-300/90',
      text23: 'text-teal-200/90',

      border: 'border-teal-400',
      border1: 'border-teal-300/30',
      border2: 'border-slate-700/50',
      border3: 'border-slate-700/30',
      border4: 'border-slate-600/30',
      border5: 'border-teal-600/50',
      border6: 'border-teal-500',
      border7: 'border-teal-700',
      border8: 'border-teal-600',
      border9: 'border-teal-800',
      border10: 'border-teal-200',
      border11: 'border-teal-500/30',
      border12: 'border-teal-500/10',
      border13: 'border-slate-600/50',
      border14: 'border-teal-400/10',
      border15: 'border-teal-500/20',
      border16: 'border-teal-400/50',
      border17: 'border-teal-800/30',
      border18: 'border-gray-700/30',
      border19: 'border-slate-700',
      border20: 'border-emerald-500/20',
      border21: 'border-slate-600',
      border22: 'border-gray-700',
      border23: 'border-teal-300/5',
      border24: 'border-teal-400/20',
      border25: 'border-teal-300',
      border26: 'border-teal-300/10',
      border27: 'border-teal-300/50',
      border28: 'border-slate-800',
      border29: 'border-teal-400/30',
      border30: 'border-teal-500/50',
      border31: 'border-slate-900',

      bg1: 'bg-teal-500/20',
      bg2: 'bg-slate-800/50',
      bg3: 'bg-slate-700/50',
      bg4: 'bg-gradient-to-br from-slate-800/90 to-slate-900/90',
      bg5: 'bg-slate-700',
      bg6: 'bg-slate-900/60',
      bg7: 'bg-gradient-to-br from-teal-500/10 via-transparent to-sky-500/10',
      bg8: 'bg-gradient-to-br from-slate-800 to-slate-900',
      bg9: 'bg-gradient-to-br from-slate-800/80 via-slate-900/80 to-slate-800/80',
      bg10: 'bg-teal-600/10',
      bg11: 'bg-teal-300/10',
      bg12: 'bg-gray-800',
      bg13: 'bg-teal-500',
      bg14: 'bg-slate-800',
      bg15: 'bg-slate-800/60',
      bg16: 'bg-slate-900',
      bg17: 'bg-slate-700/30',
      bg18: 'bg-teal-600',
      bg19: 'bg-gray-900/40',
      bg20: 'bg-gray-900/50',
      bg21: 'bg-teal-900/30',
      bg22: 'bg-gray-700/30',
      bg23: 'bg-gray-800/40',
      bg24: 'bg-slate-900/60',
      bg25: 'bg-teal-500/10',
      bg26: 'bg-gray-700',
      bg27: 'bg-slate-800/95',
      bg28: 'bg-teal-300',
      bg29: 'bg-teal-400/60',
      bg30: 'bg-teal-400/20',
      bg31: 'bg-slate-800/40',
      bg32: 'bg-slate-800/70',
      bg33: 'bg-slate-500/20',
      bg34: 'bg-slate-900/50',
      bg35: 'bg-teal-900',
      bg36: 'bg-slate-900/30',
      bg37: 'bg-teal-800/30',
      bg38: 'bg-teal-700',
      bg39: 'bg-slate-800/90',
      bg40: 'bg-teal-400',
      bg41: 'bg-teal-600/50',
      bg42: 'bg-emerald-500/20',
      bg43: 'bg-emerald-400',
      bg44: 'bg-blue-500/10',
      bg45: 'bg-slate-900/80',
      bg46: 'bg-gray-800/50',
      bg47: 'bg-slate-700/80',
      bg48: 'bg-slate-700/70',
      bg49: 'bg-emerald-500',
      bg50: 'bg-teal-900/50',
      bg51: 'bg-teal-300/5',
      bg52: 'bg-teal-300/10',
      bg53: 'bg-slate-600/90',
      bg54: 'bg-teal-300/20',
      bg55: 'bg-slate-800/80',
      bg56: 'bg-teal-900/20',
      bg57: 'bg-teal-800/50',
      bg58: 'bg-teal-400/10',
      bg59: 'bg-teal-400/5',
      bg60: 'bg-slate-800/30',
      bg61: 'bg-teal-700/20',
      bg62: 'bg-teal-600/20',
      bg63: 'bg-teal-500/5',
      bg64: 'bg-emerald-500/5',

      hover: 'hover:text-teal-500',
      hover1: 'hover:text-teal-300',
      hover2: 'hover:text-teal-200',
      hover3: 'hover:text-teal-400',
      hoverB: 'hover:border-teal-500/30',
      hoverB1: 'hover:border-teal-500/50',
      hoverB2: 'hover:border-teal-300/20',
      hoverB3: 'hover:border-emerald-400/30',
      hoverB4: 'hover:border-teal-400',
      hoverB5: 'hover:border-teal-500',
      hoverB6: 'hover:border-teal-400/30',
      hoverB7: 'hover:border-slate-600',
      hoverB8: 'hover:border-teal-400/40',
      bgHover: 'hover:bg-slate-700/70',
      bgHover1: 'hover:bg-slate-800/60',
      bgHover2: 'hover:bg-slate-800/30',
      bgHover3: 'hover:bg-teal-600/20',
      bgHover4: 'hover:bg-teal-900/20',
      bgHover5: 'hover:bg-teal-600',
      bgHover6: 'hover:bg-teal-400',
      bgHover7: 'hover:bg-teal-500/10',
      bgHover8: 'hover:bg-teal-500/5',
      bgHover9: 'hover:bg-teal-500/40',
      bgHover10: 'hover:bg-slate-600/50',
      bgHover11: 'hover:bg-teal-700',
      bgHover12: 'hover:bg-gray-800/40',
      bgHover13: 'hover:bg-teal-500/20',
      bgHover14: 'hover:bg-slate-800',
      bgHover15: 'hover:bg-slate-700/50',
      bgHover16: 'hover:bg-slate-700/30',
      bgHover17: 'hover:bg-slate-700/80',
      bgHover18: 'hover:bg-slate-800/40',
      bgHover19: 'hover:bg-slate-700/20',
      bgHover20: 'hover:bg-slate-800/70',
      bgHover21: 'hover:bg-slate-800/80',
      bgHover22: 'hover:bg-teal-600/70',
      bgHover23: 'hover:bg-emerald-600',
      bgHover24: 'hover:bg-slate-600',
      bgHover25: 'hover:bg-teal-500',
      bgHover26: 'hover:bg-teal-300/20',
      bgHover27: 'hover:bg-teal-300/30',
      bgHover28: 'hover:bg-teal-500/30',
      bgHover29: 'hover:bg-gray-700',
      bgHover30: 'hover:bg-teal-700/50',
      bgHover31: 'hover:bg-slate-700',

      textColor: 'bg-gradient-to-r from-teal-300 via-teal-400 to-teal-300',
      textColor1: 'bg-gradient-to-br from-slate-700/50 to-slate-800/50',

      groupHover: 'group-hover:border-teal-400/60',
      groupHover1: 'group-hover:border-teal-500/30',
      groupHover3: 'group-hover:text-teal-200',
      groupHover4: 'group-hover:text-teal-200/80',
      groupHover5: 'group-hover:text-teal-200/80',
      groupHover6: 'group-hover:text-emerald-200/90',
      groupHover7: 'group-hover:text-teal-300',
      groupHover8: 'group-hover:border-teal-500/50',
      groupHover9: 'group-hover:text-teal-300/60',
      groupHover10: 'group-hover:text-teal-300/80',
      groupHover11: 'group-hover:border-teal-300/50',
      groupHover12: 'group-hover:text-teal-400',
      groupHoverG: 'group-hover:from-teal-200',
      groupHoverG1: 'group-hover:via-cyan-200',
      groupHoverG2: 'group-hover:to-teal-200',
      groupHoverG3: 'hover:from-teal-600 hover:to-purple-600',
      groupHoverG4: 'hover:from-emerald-500/20 hover:to-blue-500/20',
      groupHoverG5: 'hover:from-teal-500 hover:to-teal-400',
      groupHoverG6: 'hover:from-teal-400/20 hover:to-emerald-400/20',
      groupHoverG7: 'hover:from-teal-400/10 hover:to-emerald-400/10',
      groupHoverG8: 'hover:from-teal-500/30 hover:to-teal-400/30',
      groupHoverG9: 'hover:from-teal-300 hover:to-teal-400',
      groupHoverG10: 'hover:from-teal-500 hover:via-teal-600 hover:to-teal-500',
      groupHoverG11: 'hover:from-teal-600 hover:to-emerald-600',

      groupHoverBgr:
        'hover:bg-gradient-to-r hover:from-teal-300/5 hover:to-transparent',

      groupHoverBg: 'group-hover:bg-teal-500/20',
      groupHoverBg1: 'group-hover:bg-teal-300/20',
      groupHoverBg2: 'group-hover:bg-slate-800/70',

      focus: 'focus:border-teal-300',
      focus1: 'focus:border-teal-300/50',
      focus2: 'focus:border-teal-500/50',
      focus3: 'focus:border-teal-500',
      focus4: 'focus:border-teal-400/30',
      focus5: 'focus:border-emerald-400/40',
      focus6: 'focus:border-teal-400',
      focus7: 'focus:border-teal-300/20',
      focus8: 'focus:border-teal-300/30',
      focusRing: 'focus:ring-teal-300/50',
      focusRing1: 'focus:ring-teal-500/50',
      focusRing2: 'focus:ring-teal-500',
      focusRing3: 'focus:ring-teal-500/20',
      focusRing4: 'focus:ring-emerald-500/60',
      focusRing5: 'focus:ring-teal-400',
      focusRing6: 'focus:ring-teal-300/20',
      focusRing7: 'focus:ring-teal-400/30',
      focusRing8: 'focus:ring-teal-300',
      focusRing9: 'focus:ring-offset-slate-900',
      texting: 'text-slate-200',
      texting1: 'text-slate-300',
      texting2: 'text-slate-400',
      texting3: 'text-slate-900',

      bgGradient:
        'bg-gradient-to-br from-slate-900/90 via-slate-950/95 to-slate-900/90',
      bgGradient1:
        'bg-gradient-to-tr from-emerald-500/10 via-transparent to-sky-500/10',
      bgGradient2:
        'bg-[radial-gradient(circle_at_50%_50%,rgba(16,185,129,0.12),transparent_70%)]',
      bgGradient3: 'bg-emerald-400/50',
      bgGradient4: 'bg-teal-400/30',
      bgGradient5: 'bg-sky-400/20',
      bgGradient6: 'bg-gradient-to-br from-teal-900/10 to-gray-800/20',
      bgGradient7:
        'bg-gradient-to-br from-slate-800/95 via-slate-900/95 to-slate-800/95',
      bgGradient8:
        'bg-gradient-to-br from-teal-500/10 via-teal-500/10 to-slate-500/10',
      bgGradient9: 'bg-gradient-to-br from-teal-500/20 to-slate-500/20',
      bgGradient10: 'bg-gradient-to-br from-teal-500/20 to-purple-500/20',
      bgGradient11: 'bg-gradient-to-br from-teal-500 to-teal-400',
      bgGradient12: 'bg-gradient-to-br from-slate-900/80 to-indigo-950/80',
      bgGradient13: 'bg-gradient-to-br from-slate-800/80 to-slate-900/80',
      bgGradient14: 'bg-gradient-to-r from-teal-600 to-teal-500',
      bgGradient15:
        'bg-gradient-to-br from-gray-700 via-teal-600/10 to-teal-800',
      bgGradient16:
        'bg-gradient-to-br from-teal-500/5 via-slate-900/50 to-teal-500/5',
      bgGradient17: 'bg-gradient-to-br from-teal-400/20 to-emerald-400/20',
      bgGradient18: 'bg-gradient-to-br from-teal-400 to-emerald-400',
      bgGradient19: 'bg-gradient-to-br from-gray-900 to-gray-800',
      bgGradient20:
        'bg-gradient-to-br from-slate-700 via-slate-800 to-slate-700',
      bgGradient21: 'bg-gradient-to-br from-teal-500 to-teal-600',
      bgGradient22:
        'bg-gradient-to-br from-teal-500/10 via-transparent to-transparent',
      bgGradient23: 'bg-gradient-to-br from-slate-700 to-slate-800',
      bgGradient24: 'bg-gradient-to-br from-slate-800/70 to-slate-900/70',
      bgGradient25:
        'bg-gradient-to-br from-teal-500/20 via-transparent to-transparent',
      bgGradient26: 'bg-gradient-to-br from-teal-500/20 to-emerald-500/20',
      bgGradient27: 'bg-gradient-to-br from-slate-800/80 to-slate-950/90',
      bgGradient28: 'bg-gradient-to-br from-slate-800/60 to-slate-900/60',
      bgGradient29: 'bg-gradient-to-br from-teal-400/80 to-teal-600/80',

      bgr: 'bg-gradient-to-r from-teal-300 via-teal-200 to-cyan-200',
      bgr1: 'bg-gradient-to-r from-transparent via-emerald-500/30 to-transparent',
      bgr2: 'bg-gradient-to-r from-slate-800 to-slate-900',
      bgr3: 'bg-gradient-to-r from-teal-500/10 to-slate-900/10',
      bgr4: 'bg-gradient-to-r from-teal-300 to-teal-400',
      bgr5: 'bg-gradient-to-r from-teal-300 via-teal-200 to-purple-300',
      bgr6: 'bg-gradient-to-r from-teal-300 via-teal-200 to-teal-400',
      bgr7: 'bg-gradient-to-r from-teal-500 to-teal-400',
      bgr8: 'bg-gradient-to-r from-transparent via-emerald-500/50 to-transparent',
      bgr9: 'bg-gradient-to-r from-emerald-500/5 via-blue-500/5 to-purple-500/5',
      bgr10: 'bg-gradient-to-r from-emerald-500/10 to-blue-500/10',
      bgr11: 'bg-gradient-to-r from-transparent via-blue-500/50 to-transparent',
      bgr12: 'bg-gradient-to-r from-emerald-500 to-teal-500',
      bgr13: 'bg-gradient-to-r from-emerald-400 via-teal-400 to-blue-400',
      bgr14: 'bg-gradient-to-r from-emerald-500 via-teal-500 to-blue-500',
      bgr15: 'bg-gradient-to-r from-teal-300 to-teal-500',
      bgr16: 'bg-gradient-to-r from-teal-500 to-green-500',
      bgr17: 'bg-gradient-to-r from-teal-500 to-emerald-600',
      bgr18: 'bg-gradient-to-r from-gray-600 to-gray-700',
      bgr19: 'bg-gradient-to-r from-teal-400 to-teal-500',
      bgr20: 'bg-gradient-to-r from-teal-300/10 to-transparent',
      bgr21: 'bg-gradient-to-r from-teal-300/20 to-teal-400/20',
      bgr22: 'bg-gradient-to-r from-teal-300 to-emerald-300',
      bgr23: 'bg-gradient-to-r from-teal-400/10 to-emerald-400/10',
      bgr24: 'bg-gradient-to-r from-teal-400/5 to-emerald-400/5',
      bgr25: 'bg-gradient-to-r from-teal-500 via-emerald-500 to-teal-500',
      bgr26: 'bg-gradient-to-r from-teal-300 via-emerald-300 to-teal-300',
      bgr27: 'bg-gradient-to-r from-teal-500/20 to-teal-400/20',
      bgr28: 'bg-gradient-to-r from-teal-400 to-emerald-400',
      bgr29: 'bg-gradient-to-r from-slate-600 to-slate-700',
      bgr30: 'bg-gradient-to-r from-blue-900/30 to-teal-900/30',
      bgr31: 'bg-gradient-to-r from-slate-700/50 to-slate-700/30',
      bgr32: 'bg-gradient-to-r from-teal-400 via-teal-500 to-teal-600',
      bgr33: 'bg-gradient-to-r from-teal-600/20 to-teal-500/20',
      bgr34: 'bg-gradient-to-r from-teal-900/30 to-slate-900/10',
      bgr35: 'bg-gradient-to-r from-teal-600/5 to-slate-800/5',
      bgr36: 'bg-gradient-to-r from-slate-900 to-slate-800',
      bgr37: 'bg-gradient-to-r from-teal-500/0 via-teal-400 to-teal-500/0',
      bgr38: 'bg-gradient-to-r from-teal-400 via-teal-500 to-teal-400',
      bgr39:
        'bg-gradient-to-r from-slate-900/80 via-blue-900/50 to-teal-900/50',
      bgr40: 'bg-gradient-to-r from-teal-500 to-blue-500',
      bgr41: 'bg-gradient-to-r from-teal-400 to-blue-500',
      bgr42: 'bg-gradient-to-r from-teal-300 via-blue-300 to-purple-300',
      bgr43:
        'bg-gradient-to-r from-teal-500/20 to-blue-500/20 border border-teal-500/20',
      bgr44: 'bg-gradient-to-r from-teal-500/10 to-emerald-500/10',
      bgr45: 'bg-gradient-to-r from-slate-800/80 to-slate-900/80',
      bgr46: 'bg-gradient-to-r from-transparent via-teal-500/70 to-transparent',
      bgr47: 'bg-gradient-to-r from-teal-500 to-emerald-500',
      bgr48: 'bg-gradient-to-r from-teal-500/20 to-emerald-500/20',
      bgr49: 'bg-gradient-to-r from-transparent via-teal-500/50 to-transparent',
      bgr50: 'bg-gradient-to-r from-teal-500/5 to-emerald-500/5',
      bgr51: 'bg-gradient-to-r from-teal-500/20 to-cyan-500/20',
      bgr52: 'bg-gradient-to-r from-teal-400/30 via-teal-500/50 to-teal-400/30',
      bgr53: 'bg-gradient-to-r from-transparent via-teal-400/40 to-transparent',
      bgr54: 'bg-gradient-to-r from-transparent via-teal-400/20 to-transparent',
      bgr55: 'bg-gradient-to-r from-teal-500/5 via-teal-400/30 to-teal-500/5',
      bgr56: 'bg-gradient-to-r from-teal-500/5 via-teal-400/30 to-teal-500/5',
      bgr57: 'bg-gradient-to-r from-teal-600/20 to-teal-500/5',
      bgr58: 'bg-gradient-to-r from-transparent via-teal-400/70 to-transparent',
      bgr59: 'bg-gradient-to-r from-teal-500/5 to-transparent',
      bgr60: 'bg-gradient-to-r from-teal-400/30 to-teal-500/30',
      bgr61: 'bg-gradient-to-r from-slate-800/50 to-slate-700/30',

      BgBottom: 'bg-gradient-to-b from-teal-400 to-cyan-500',
      BgBottom1:
        'bg-gradient-to-b from-transparent via-emerald-500/50 to-transparent',
      BgBottom2:
        'bg-gradient-to-b from-transparent via-blue-500/50 to-transparent',
      BgBottom3: 'bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900',
      BgBottom4: 'bg-gradient-to-b from-gray-800 to-gray-900',
      BgBottom5: 'bg-gradient-to-b from-teal-500/5 to-transparent',
      BgBottom6: 'bg-gradient-to-b from-slate-800 to-slate-900',
      BgBottom7:
        'bg-gradient-to-b from-transparent via-teal-500/50 to-transparent',
      BgBottom8:
        'bg-gradient-to-b from-transparent via-teal-500/30 to-transparent',
      BgBottom9:
        'bg-gradient-to-b from-transparent via-emerald-500/30 to-transparent',
      BgBottom10:
        'bg-gradient-to-b from-transparent via-teal-400/50 to-transparent',
      BgBottom11:
        'bg-gradient-to-b from-transparent via-teal-400/30 to-transparent',
      BgBottom12:
        'bg-gradient-to-b from-teal-500/5 via-teal-400/40 to-teal-500/5',

      BgTop: 'bg-gradient-to-t from-slate-900 to-transparent',

      BgTopLeft:
        'bg-gradient-to-tl from-slate-900/50 via-transparent to-transparent',

      active: 'active:text-teal-600',
      active1: 'active:bg-teal-500/40',
      placeHolder: 'placeholder-teal-300/50',
      placeHolder1: 'placeholder-teal-500/50',
      placeHolder2: 'placeholder-teal-300/30',
      placeHolder3: 'placeholder-slate-400',
      placeHolder4: 'placeholder-slate-500',
      placeHolder5: 'placeholder:text-slate-500',
      ringColor: 'ring-teal-300/50',
      ringColor1: 'ring-teal-500',
      ringColor2: 'ring-teal-400/30',
      ringColor3: 'ring-slate-800/50',
      ringColor4: 'ring-teal-300/20',
      ringColor5: 'ring-slate-900',
      ringColor6: 'ring-teal-400',
      divide: 'divide-slate-700/30',
      divide1: 'divide-slate-700/50',
      divide2: 'divide-teal-300/10',
      groupDisabled: 'text-teal-300/50',
      ringHover: 'hover:ring-teal-300/50',
      ringHoverG: 'group-hover:ring-teal-300/40',
      bgFocus: 'focus:bg-slate-600',
      shadow: 'shadow-slate-900/20',
      shadow1: 'shadow-slate-800/20',
      shadow2: 'shadow-slate-900/30',
      shadow3: 'shadow-teal-400/20',
      shadow4: 'shadow-teal-300/20',
      shadow5: 'shadow-teal-500/20',
      shadow6: 'shadow-slate-900/70',
      shadowhover: 'group-hover:shadow-emerald-500/10',
      shadowhover1: 'hover:shadow-teal-500/20',
      shadowhover2: 'hover:shadow-teal-900/30',
      shadowhover3: 'hover:shadow-teal-500/25',
      shadowhover4: 'hover:shadow-emerald-500/10',
      shadowhover5: 'hover:shadow-emerald-900/10',
      shadowhover6: 'hover:shadow-teal-300/10',
      shadowhover7: 'hover:shadow-teal-500/60',
      shadowhover8: 'hover:shadow-slate-500/20',
      shadowhover9: 'hover:shadow-emerald-500/40',
      shadowhover10: 'shadow-teal-500/10',
      shadowhover11: 'hover:shadow-teal-500/40',

      shadowing: 'shadow-teal-500/30',
      shadowing1: 'shadow-emerald-500/20',
      shadowing2: 'shadow-teal-500/40',

      // Extra Bg Color
      bgEx: 'bg-purple-400/5',
      bgEx1: 'bg-blue-600/10'
    },
    mui: {
      main: '#2DD4BF',
      hover: '#14B8A6',
      active: '#0D9488',
      border: '#2DD4BF',
      border1: 'rgba(45, 212, 191, 0.2)',
      fill: 'rgba(45, 212, 191, 0.1)',
      cart: '#475569',
      light: '#5EEAD4',
      bg2: 'rgba(26, 31, 46, 0.8), rgba(26, 31, 46, 0.8)',

      // Excel Export Expenses
      bge1: '#1E293B',
      main1: '#14b8a6',
      shadowE: 'rgba(20, 184, 166, 0.3)',
      shadowE1: 'rgba(20, 184, 166, 0.7)',
      shadowE2: '0 0 15px rgba(45, 212, 191, 0.5)',
      shadowE3: '0 0 8px 2px rgba(45, 212, 191, 0.3)',
      shadowE4:
        '0 0 40px rgba(0, 0, 0, 0.5), inset 0 0 2px rgba(45, 212, 191, 0.3)',

      // Salary History
      BgLinear: 'linear-gradient(to bottom right, #1e293b, #0f172a, #1e293b)',
      BgLinear1:
        'linear-gradient(90deg, transparent, rgba(45, 212, 191, 0.1), transparent)',
      // Approve scholarship
      bgA: '#0d9488',

      // Customer Profile
      mainC: '#5eead4',
      mainC1: '#3b82f6',
      bgC: '#334155',

      // custom scroll bar:
      bgCB: 'rgba(45, 212, 191, 0.3)',
      bgCB1: 'rgba(45, 212, 191, 0.5)'
    }
  },
  {
    tailwind: {
      // User management
      text: 'text-yellow-400',
      text1: 'text-yellow-400/60',
      text2: 'text-yellow-300/50',
      text3: 'text-yellow-600',
      text4: 'text-yellow-300/90',
      text5: 'bg-gradient-to-r from-yellow-500 to-amber-500',
      text6: 'bg-gradient-to-r from-yellow-300 to-amber-300',
      text7: 'text-yellow-400/90',
      text8: 'bg-gradient-to-r from-yellow-300 to-yellow-500',
      text9: 'text-yellow-300',
      text10: 'text-yellow-500',
      text11: 'text-yellow-300/80',
      text12: 'text-yellow-400/70',
      text13: 'text-white',
      text14: 'text-white/80',
      text15: 'text-amber-400',
      text16: 'text-amber-500',
      text17: 'text-white/70',
      text18: 'text-gray-300/80',
      text19: 'text-gray-200',
      text20: 'text-yellow-300/60',
      text21: 'text-yellow-300/40',
      text22: 'text-yellow-300/90',
      text23: 'text-yellow-300/90',

      textColor:
        'bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-400',
      textColor1: 'bg-gradient-to-br from-slate-400/50 to-slate-500/50',

      border: 'border-yellow-400',
      border1: 'border-yellow-400/30',
      border2: 'border-yellow-500/50',
      border3: 'border-slate-400/30',
      border4: 'border-slate-300/30',
      border5: 'border-yellow-600/50',
      border6: 'border-yellow-500',
      border7: 'border-yellow-400',
      border8: 'border-yellow-600',
      border9: 'border-yellow-500',
      border10: 'border-yellow-200',
      border11: 'border-yellow-500/30',
      border12: 'border-yellow-500/10',
      border13: 'border-gray-600/50',
      border14: 'border-yellow-400/10',
      border15: 'border-yellow-500/20',
      border16: 'border-yellow-400/50',
      border17: 'border-yellow-800/30',
      border18: 'border-gray-300/30',
      border19: 'border-gray-500',
      border20: 'border-amber-500/20',
      border21: 'border-slate-400',
      border22: 'border-gray-400',
      border23: 'border-yellow-300/5',
      border24: 'border-yellow-400/20',
      border25: 'border-yellow-300',
      border26: 'border-yellow-300/10',
      border27: 'border-yellow-300/50',
      border28: 'border-slate-500',
      border29: 'border-yellow-400/30',
      border30: 'border-yellow-500/50',
      border31: 'border-slate-500',

      hover: 'hover:text-yellow-500',
      hover1: 'hover:text-yellow-300',
      hover2: 'hover:text-yellow-200',
      hover3: 'hover:text-yellow-400',
      hoverB: 'hover:border-yellow-500/30',
      hoverB1: 'hover:border-yellow-500/50',
      hoverB2: 'hover:border-yellow-300/20',
      hoverB3: 'hover:border-amber-400/30',
      hoverB4: 'hover:border-yellow-400',
      hoverB5: 'hover:border-yellow-500',
      hoverB6: 'hover:border-yellow-400/30',
      hoverB7: 'hover:border-gray-400',
      hoverB8: 'hover:border-yellow-400/40',
      bgHover: 'hover:bg-slate-300/70',
      bgHover1: 'hover:bg-slate-400/60',
      bgHover2: 'hover:bg-slate-400/30',
      bgHover3: 'hover:bg-yellow-400/20',
      bgHover4: 'hover:bg-yellow-900/20',
      bgHover5: 'hover:bg-yellow-600',
      bgHover6: 'hover:bg-yellow-400',
      bgHover7: 'hover:bg-yellow-500/10',
      bgHover8: 'hover:bg-yellow-500/5',
      bgHover9: 'hover:bg-yellow-500/40',
      bgHover10: 'hover:bg-slate-200/50',
      bgHover11: 'hover:bg-yellow-700',
      bgHover12: 'hover:bg-gray-400/40',
      bgHover13: 'hover:bg-yellow-500/20',
      bgHover14: 'hover:bg-slate-500/70',
      bgHover15: 'hover:bg-slate-400/50',
      bgHover16: 'hover:bg-slate-400/30',
      bgHover17: 'hover:bg-slate-400/80',
      bgHover18: 'hover:bg-slate-500/40',
      bgHover19: 'hover:bg-slate-400/20 ',
      bgHover20: 'hover:bg-slate-500/70 ',
      bgHover21: 'hover:bg-slate-500/80',
      bgHover22: 'hover:bg-yellow-600/70',
      bgHover23: 'hover:bg-amber-600',
      bgHover24: 'hover:bg-zinc-400',
      bgHover25: 'hover:bg-yellow-500',
      bgHover26: 'hover:bg-yellow-300/20',
      bgHover27: 'hover:bg-yellow-300/30',
      bgHover28: 'hover:bg-yellow-500/30',
      bgHover29: 'hover:bg-gray-300',
      bgHover30: 'hover:bg-yellow-500/50',
      bgHover31: 'hover:bg-slate-400',

      groupHover: 'group-hover:border-yellow-400/60',
      groupHover1: 'group-hover:border-yellow-500/30',
      groupHover2: 'group-hover:border-emerald-500/20',
      groupHover3: 'group-hover:text-yellow-200',
      groupHover4: 'group-hover:text-yellow-200/80',
      groupHover5: 'group-hover:text-yellow-200/80',
      groupHover6: 'group-hover:text-amber-200/90',
      groupHover7: 'group-hover:text-yellow-300',
      groupHover8: 'group-hover:border-yellow-500/50',
      groupHover9: 'group-hover:text-yellow-300/60',
      groupHover10: 'group-hover:text-yellow-300/80',
      groupHover11: 'group-hover:border-yellow-300/50',
      groupHover12: 'group-hover:text-yellow-400',
      groupHoverG: 'group-hover:from-yellow-200',
      groupHoverG1: 'group-hover:via-amber-200',
      groupHoverG2: 'group-hover:to-yellow-200',
      groupHoverG3: 'hover:from-yellow-600 hover:to-purple-600',
      groupHoverG4: 'hover:from-amber-500/20 hover:to-lime-500/20',
      groupHoverG5: 'hover:from-yellow-500 hover:to-yellow-400',
      groupHoverG6: 'hover:from-yellow-400/20 hover:to-yellow-400/20',
      groupHoverG7: 'hover:from-yellow-400/10 hover:to-amber-400/10',
      groupHoverG8: 'hover:from-yellow-500/30 hover:to-yellow-400/30',
      groupHoverG9: 'hover:from-yellow-300 hover:to-yellow-400',
      groupHoverG10:
        'hover:from-yellow-500 hover:via-yellow-600 hover:to-yellow-500',
      groupHoverG11: 'hover:from-yellow-600 hover:to-amber-600',

      groupHoverBgr:
        'hover:bg-gradient-to-r hover:from-yellow-300/5 hover:to-transparent',

      groupHoverBg: 'group-hover:bg-yellow-500/20',
      groupHoverBg1: 'group-hover:bg-yellow-300/20',
      groupHoverBg2: 'group-hover:bg-slate-500/70',

      focus: 'focus:border-yellow-400',
      focus1: 'focus:border-yellow-400/50',
      focus2: 'focus:border-yellow-500/50 ',
      focus3: 'focus:border-yellow-500',
      focus4: 'focus:border-yellow-400/30',
      focus5: 'focus:border-amber-400/40',
      focus6: 'focus:border-yellow-400',
      focus7: 'focus:border-yellow-300/20',
      focus8: 'focus:border-yellow-300/30',
      focusRing: 'focus:ring-yellow-300/50',
      focusRing1: 'focus:ring-yellow-500/50',
      focusRing2: 'focus:ring-yellow-500',
      focusRing3: 'focus:ring-yellow-500/20',
      focusRing4: 'focus:ring-amber-500/60',
      focusRing5: 'focus:ring-yellow-400',
      focusRing6: 'focus:ring-yellow-300/20',
      focusRing7: 'focus:ring-yellow-400/30',
      focusRing8: 'focus:ring-yellow-300',
      focusRing9: 'focus:ring-offset-slate-500',
      bgFocus: 'focus:bg-slate-300',

      texting: 'text-slate-100',
      texting1: 'text-white/60',
      texting2: 'text-white/90',
      texting3: 'text-white/95',

      bg1: 'bg-yellow-500/20',
      bg2: 'bg-slate-500/50',
      bg3: 'bg-slate-300/50',
      bg4: 'bg-gradient-to-br from-gray-400/90 to-gray-500/90',
      bg5: 'bg-gray-500',
      bg6: 'bg-slate-500/60',
      bg7: 'bg-gradient-to-br from-yellow-500/10 via-transparent to-amber-500/10',
      bg8: 'bg-gradient-to-br from-slate-500 to-slate-600',
      bg9: 'bg-gradient-to-br from-slate-400/80 via-slate-500/80 to-slate-400/80',
      bg10: 'bg-yellow-400/10',
      bg11: 'bg-yellow-300/10',
      bg12: 'bg-gray-400',
      bg13: 'bg-yellow-500',
      bg14: 'bg-slate-400/70',
      bg15: 'bg-slate-400/60',
      bg16: 'bg-slate-600',
      bg17: 'bg-slate-300/30',
      bg18: 'bg-yellow-600',
      bg19: 'bg-gray-600/80',
      bg20: 'bg-gray-400/50',
      bg21: 'bg-yellow-700/30',
      bg22: 'bg-gray-300/30',
      bg23: 'bg-gray-400/40',
      bg24: 'bg-slate-500/60',
      bg25: 'bg-yellow-500/10',
      bg26: 'bg-gray-400',
      bg27: 'bg-slate-500/95',
      bg28: 'bg-yellow-300',
      bg29: 'bg-yellow-400/60',
      bg30: 'bg-yellow-400/20',
      bg31: 'bg-slate-500/40',
      bg32: 'bg-slate-500/70',
      bg33: 'bg-slate-200/20',
      bg34: 'bg-slate-500/30',
      bg35: 'bg-yellow-900',
      bg36: 'bg-slate-500/30',
      bg37: 'bg-yellow-800/30',
      bg38: 'bg-yellow-700',
      bg39: 'bg-slate-500/90',
      bg40: 'bg-yellow-400',
      bg41: 'bg-yellow-600/50',
      bg42: 'bg-amber-500/10',
      bg43: 'bg-amber-400',
      bg44: 'bg-lime-500/10',
      bg45: 'bg-slate-500/80',
      bg46: 'bg-gray-400/50',
      bg47: 'bg-zinc-400/80',
      bg48: 'bg-zinc-700/70',
      bg49: 'bg-amber-500',
      bg50: 'bg-yellow-600/50',
      bg51: 'bg-yellow-300/5',
      bg52: 'bg-yellow-300/10',
      bg53: 'bg-slate-600/90',
      bg54: 'bg-yellow-300/20',
      bg55: 'bg-slate-500/80',
      bg56: 'bg-yellow-500/20',
      bg57: 'bg-yellow-500/50',
      bg58: 'bg-yellow-400/10',
      bg59: 'bg-yellow-400/5',
      bg60: 'bg-slate-400/30',
      bg61: 'bg-yellow-700/20',
      bg62: 'bg-yellow-600/20',
      bg63: 'bg-yellow-500/5',
      bg64: 'bg-amber-500/5',

      shadow: 'shadow-slate-400/20',
      shadow1: 'shadow-slate-500/20',
      shadow2: 'shadow-slate-500/30',
      shadow3: 'shadow-yellow-400/20',
      shadow4: 'shadow-yellow-300/20',
      shadow5: 'shadow-yellow-500/20',
      shadow6: 'shadow-slate-500/70',
      shadowhover: 'group-hover:shadow-amber-500/10',
      shadowhover1: 'hover:shadow-yellow-500/20',
      shadowhover2: 'hover:shadow-yellow-900/30',
      shadowhover3: 'hover:shadow-yellow-500/25',
      shadowhover4: 'hover:shadow-amber-500/10',
      shadowhover5: 'hover:shadow-amber-900/10',
      shadowhover6: 'hover:shadow-yellow-300/10',
      shadowhover7: 'hover:shadow-yellow-500/60',
      shadowhover8: 'hover:shadow-gray-300/20',
      shadowhover9: 'hover:shadow-amber-500/40',
      shadowhover10: 'shadow-yellow-500/10',
      shadowhover11: 'hover:shadow-yellow-500/40',

      bgGradient:
        'bg-gradient-to-br from-slate-500/90 via-slate-550/95 to-slate-500/90',
      bgGradient1:
        'bg-gradient-to-tr from-amber-500/10 via-transparent to-lime-500/10',
      bgGradient2:
        'bg-[radial-gradient(circle_at_50%_50%,rgba(255,223,0,0.12),transparent_70%)]',
      bgGradient3: 'bg-amber-400/50',
      bgGradient4: 'bg-yellow-400/30',
      bgGradient5: 'bg-lime-400/20',
      bgGradient6: 'bg-gradient-to-br from-yellow-900/10 to-gray-400/20',
      bgGradient7:
        'bg-gradient-to-br from-slate-500/95 via-slate-500/95 to-slate-500/95',
      bgGradient8:
        'bg-gradient-to-br from-yellow-500/10 via-yellow-500/10 to-slate-200/10',
      bgGradient9: 'bg-gradient-to-br from-yellow-500/20 to-slate-200/20',
      bgGradient10: 'bg-gradient-to-br from-yellow-500/20 to-lime-500/20',
      bgGradient11: 'bg-gradient-to-br from-yellow-500 to-yellow-400',
      bgGradient12: 'bg-gradient-to-br from-slate-500/80 to-indigo-550/80',
      bgGradient13: 'bg-gradient-to-br from-slate-400/80 to-slate-500/80',

      bgGradient14: 'bg-gradient-to-r from-yellow-600 to-yellow-500',
      bgGradient15:
        'bg-gradient-to-br from-gray-500 via-yellow-600/10 to-yellow-700',
      bgGradient16:
        'bg-gradient-to-br from-yellow-500/5 via-slate-500/50 to-yellow-500/5',
      bgGradient17: 'bg-gradient-to-br from-yellow-400/20 to-amber-400/20',
      bgGradient18: 'bg-gradient-to-br from-yellow-400 to-amber-400',
      bgGradient19: 'bg-gradient-to-br from-gray-500 to-gray-400',
      bgGradient20:
        'bg-gradient-to-br from-slate-400 via-slate-500 to-slate-400',
      bgGradient21: 'bg-gradient-to-br from-yellow-500 to-yellow-600',
      bgGradient22:
        'bg-gradient-to-br from-yellow-500/10 via-transparent to-transparent',
      bgGradient23: 'bg-gradient-to-br from-slate-400 to-slate-500',
      bgGradient24: 'bg-gradient-to-br from-slate-500/70 to-slate-600/70',
      bgGradient25:
        'bg-gradient-to-br from-yellow-500/20 via-transparent to-transparent',
      bgGradient26: 'bg-gradient-to-br from-yellow-500/20 to-amber-500/20',
      bgGradient27: 'bg-gradient-to-br from-slate-500/80 to-slate-600/90',
      bgGradient28: 'bg-gradient-to-br from-slate-400/60 to-slate-500/60',
      bgGradient29: 'bg-gradient-to-br from-yellow-400/80 to-yellow-600/80',

      bgr: 'bg-gradient-to-r from-yellow-300 via-yellow-200 to-amber-200',
      bgr1: 'bg-gradient-to-r from-transparent via-amber-500/30 to-transparent',
      bgr2: 'bg-gradient-to-r from-slate-400 to-slate-500',
      bgr3: 'bg-gradient-to-r from-yellow-500/10 to-slate-400/10',
      bgr4: 'bg-gradient-to-r from-yellow-300 to-yellow-400',
      bgr5: 'bg-gradient-to-r from-yellow-300 via-yellow-200 to-lime-300',
      bgr6: 'bg-gradient-to-r from-yellow-400 via-yellow-400 to-yellow-500',
      bgr7: 'bg-gradient-to-r from-yellow-500 to-yellow-400',
      bgr8: 'bg-gradient-to-r from-transparent via-amber-500/50 to-transparent',
      bgr9: 'bg-gradient-to-r from-amber-500/5 via-lime-500/5 to-orange-500/5',
      bgr10: 'bg-gradient-to-r from-amber-500/10 to-lime-500/10',
      bgr11: 'bg-gradient-to-r from-transparent via-lime-500/50 to-transparent',
      bgr12: 'bg-gradient-to-r from-amber-500 to-yellow-500',
      bgr13: 'bg-gradient-to-r from-amber-400 via-yellow-400 to-lime-400',
      bgr14: 'bg-gradient-to-r from-amber-500 via-yellow-500 to-lime-500',
      bgr15: 'bg-gradient-to-r from-yellow-300 to-yellow-500',
      bgr16: 'bg-gradient-to-r from-yellow-500 to-lime-500',
      bgr17: 'bg-gradient-to-r from-yellow-500 to-amber-400',
      bgr18: 'bg-gradient-to-r from-gray-300 to-gray-400',
      bgr19: 'bg-gradient-to-r from-yellow-400 to-yellow-500',
      bgr20: 'bg-gradient-to-r from-yellow-300/10 to-transparent',
      bgr21: 'bg-gradient-to-r from-yellow-300/20 to-yellow-400/20',
      bgr22: 'bg-gradient-to-r from-yellow-300 to-amber-300',
      bgr23: 'bg-gradient-to-r from-yellow-400/10 to-amber-400/10',
      bgr24: 'bg-gradient-to-r from-yellow-400/5 to-amber-400/5',
      bgr25: 'bg-gradient-to-r from-yellow-500 via-amber-500 to-yellow-500',
      bgr26: 'bg-gradient-to-r from-yellow-300 via-amber-300 to-yellow-300',
      bgr27: 'bg-gradient-to-r from-yellow-500/20 to-yellow-400/20',
      bgr28: 'bg-gradient-to-r from-yellow-400 to-amber-400',
      bgr29: 'bg-gradient-to-r from-slate-300 to-slate-400',
      bgr30: 'bg-gradient-to-r from-lime-900/30 to-yellow-900/30',
      bgr31: 'bg-gradient-to-r from-slate-400/50 to-slate-400/30',
      bgr32: 'bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-600',
      bgr33: 'bg-gradient-to-r from-yellow-600/20 to-yellow-500/20',
      bgr34: 'bg-gradient-to-r from-yellow-900/30 to-slate-500/10',
      bgr35: 'bg-gradient-to-r from-yellow-600/5 to-slate-400/5',
      bgr36: 'bg-gradient-to-r from-slate-600 to-slate-500',
      bgr37:
        'bg-gradient-to-r from-yellow-500/0 via-yellow-400 to-yellow-500/0',
      bgr38: 'bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-400',
      bgr39:
        'bg-gradient-to-r from-slate-500/80 via-lime-500/50 to-yellow-500/50',
      bgr40: 'bg-gradient-to-r from-yellow-500 to-lime-500',
      bgr41: 'bg-gradient-to-r from-yellow-400 to-lime-500',
      bgr42: 'bg-gradient-to-r from-yellow-300 via-lime-300 to-orange-300',
      bgr43:
        'bg-gradient-to-r from-yellow-500/20 to-lime-500/20 border border-yellow-500/20',
      bgr44: 'bg-gradient-to-r yellow-teal-500/10 to-amber-500/10',
      bgr45: 'bg-gradient-to-r from-slate-500/80 to-slate-600/80',
      bgr46:
        'bg-gradient-to-r from-transparent via-yellow-500/70 to-transparent',
      bgr47: 'bg-gradient-to-r from-yellow-500 to-amber-500',
      bgr48: 'bg-gradient-to-r from-yellow-500/20 to-amber-500/20',
      bgr49:
        'bg-gradient-to-r from-transparent via-yellow-500/50 to-transparent',
      bgr50: 'bg-gradient-to-r from-yellow-500/5 to-amber-500/5',
      bgr51: 'bg-gradient-to-r from-yellow-500/20 to-amber-500/20',
      bgr52:
        'bg-gradient-to-r from-yellow-400/30 via-yellow-500/50 to-yellow-400/30',
      bgr53:
        'bg-gradient-to-r from-transparent via-yellow-400/40 to-transparent',
      bgr54:
        'bg-gradient-to-r from-transparent via-yellow-400/20 to-transparent',
      bgr55:
        'bg-gradient-to-r from-yellow-500/5 via-yellow-400/30 to-yellow-500/5',
      bgr56:
        'bg-gradient-to-r from-yellow-500/5 via-yellow-400/30 to-yellow-500/5',
      bgr57: 'bg-gradient-to-r from-yellow-600/20 to-yellow-500/5',
      bgr58:
        'bg-gradient-to-r from-transparent via-yellow-400/70 to-transparent',
      bgr59: 'bg-gradient-to-r from-yellow-500/5 to-transparent',
      bgr60: 'bg-gradient-to-r from-yellow-400/30 to-yellow-500/30',
      bgr61: 'bg-gradient-to-r from-slate-400/50 to-slate-300/30',

      BgBottom: 'bg-gradient-to-b from-yellow-400 to-amber-500',
      BgBottom1:
        'bg-gradient-to-b from-transparent via-amber-500/50 to-transparent',
      BgBottom2:
        'bg-gradient-to-b from-transparent via-lime-500/50 to-transparent',
      BgBottom3: 'bg-gradient-to-b from-slate-500 via-slate-400 to-slate-500',
      BgBottom4: 'bg-gradient-to-b from-gray-400 to-gray-500',
      BgBottom5: 'bg-gradient-to-b from-yellow-500/5 to-transparent',
      BgBottom6: 'bg-gradient-to-b from-slate-500 to-slate-600',
      BgBottom7:
        'bg-gradient-to-b from-transparent via-yellow-500/50 to-transparent',
      BgBottom8:
        'bg-gradient-to-b from-transparent via-yellow-500/30 to-transparent',
      BgBottom9:
        'bg-gradient-to-b from-transparent via-amber-500/30 to-transparent',
      BgBottom10:
        'bg-gradient-to-b from-transparent via-yellow-400/50 to-transparent',
      BgBottom11:
        'bg-gradient-to-b from-transparent via-yellow-400/30 to-transparent',
      BgBottom12:
        'bg-gradient-to-b from-yellow-500/5 via-yellow-400/40 to-yellow-500/5',

      BgTop: 'bg-gradient-to-t from-slate-500 to-transparent',

      BgTopLeft:
        'bg-gradient-to-tl from-slate-500/50 via-transparent to-transparent',

      ringHover: 'hover:ring-yellow-300/50',
      ringHoverG: 'group-hover:ring-yellow-300/40',
      placeHolder: 'placeholder-yellow-400/50',
      placeHolder1: 'placeholder-yellow-300/50',
      placeHolder2: 'placeholder-yellow-300/30',
      placeHolder3: 'placeholder-white',
      placeHolder4: 'placeholder-white/70',
      placeHolder5: 'placeholder:text-white/80',
      ringColor: 'ring-yellow-300/50',
      ringColor1: 'ring-yellow-500',
      ringColor2: 'ring-yellow-400/30',
      ringColor3: 'ring-slate-400/50',
      ringColor4: 'ring-yellow-300/20',
      ringColor5: 'ring-slate-500',
      ringColor6: 'ring-yellow-400',
      divide: 'divide-slate-400/30',
      divide1: 'divide-slate-300/50',
      divide2: 'divide-yellow-300/10',
      groupDisabled: 'text-yellow-300/50',
      drop_shadow: 'drop-shadow-[0_0_10px_rgba(13,148,136,0.6)]',
      shadows: 'shadow-[0_8px_32px_0_rgba(0,0,0,0.36)]',

      active: 'active:text-yellow-600',
      active1: 'active:bg-yellow-500/40',

      shadowing: 'shadow-yellow-500/30',
      shadowing1: 'shadow-amber-500/20',
      shadowing2: 'shadow-yellow-500/40',

      // Extra Bg Color
      bgEx: 'bg-orange-400/5',
      bgEx1: 'bg-amber-600/10'
    },
    mui: {
      main: '#FACC15',
      hover: '#EAB308',
      active: '#CA8A04',
      border: '#FACC15',
      border1: 'rgba(250, 204, 21, 0.2)',
      fill: 'rgba(250, 204, 21, 0.1)',
      cart: '#FFFF',
      light: '#facc15',
      bg2: 'rgba(100,116,139,0.6), rgba(71,85,105,0.7)',

      // Excel Export Expenses
      bge1: '#64748b',
      main1: '#b8b814',
      shadowE: 'rgba(184, 184, 20, 0.3)',
      shadowE1: 'rgba(184, 184, 20, 0.7)',
      shadowE2: '0 0 15px rgba(250, 204, 21, 0.5)',
      shadowE3: '0 0 8px 2px rgba(255, 221, 0, 0.4)',
      shadowE4:
        '0 0 40px rgba(0, 0, 0, 0.5), inset 0 0 2px rgba(255, 221, 0, 0.3)',
      // Salary History
      BgLinear: 'linear-gradient(to bottom right, #64748b, #475569, #64748b)',
      BgLinear1:
        'linear-gradient(90deg, transparent, rgba(253, 224, 71, 0.1), transparent)',

      // Approve scholarship
      bgA: '#FFDE21',

      // Customer Profile
      mainC: '#fde68a',
      mainC1: '#84cc16',
      bgC: '#4b5563',

      // custom scroll bar:
      bgCB: 'rgba(250, 204, 21, 0.3)',
      bgCB1: 'rgba(250, 204, 21, 0.5)'
    }
  },
  {
    tailwind: {
      // User management - Purple theme (dark)
      text: 'text-purple-400',
      text1: 'text-purple-400/60',
      text2: 'text-purple-300/50',
      text3: 'text-purple-600',
      text4: 'text-purple-300/70',
      text5: 'bg-gradient-to-r from-purple-500 to-indigo-500',
      text6: 'bg-gradient-to-r from-purple-300 to-indigo-300',
      text7: 'text-purple-300/30',
      text8: 'bg-gradient-to-r from-purple-400 to-purple-600',
      text9: 'text-purple-300',
      text10: 'text-purple-500',
      text11: 'text-purple-300/80',
      text12: 'text-purple-400/70',
      text13: 'text-white',
      text14: 'text-white/80',
      text15: 'text-indigo-400',
      text16: 'text-violet-400',
      text17: 'text-slate-500',
      text18: 'text-slate-500',
      text19: 'text-gray-400',
      text20: 'text-purple-300/60',
      text21: 'text-purple-300/40',
      text22: 'text-purple-300/90',
      text23: 'text-purple-200/90',

      border: 'border-purple-400',
      border1: 'border-purple-300/30',
      border2: 'border-slate-700/50',
      border3: 'border-slate-700/30',
      border4: 'border-slate-600/30',
      border5: 'border-purple-600/50',
      border6: 'border-purple-500',
      border7: 'border-purple-700',
      border8: 'border-purple-600',
      border9: 'border-purple-800',
      border10: 'border-purple-200',
      border11: 'border-purple-500/30',
      border12: 'border-purple-500/10',
      border13: 'border-slate-600/50',
      border14: 'border-purple-400/10',
      border15: 'border-purple-500/20',
      border16: 'border-purple-400/50',
      border17: 'border-purple-800/30',
      border18: 'border-gray-700/30',
      border19: 'border-slate-700',
      border20: 'border-violet-500/20',
      border21: 'border-slate-600',
      border22: 'border-gray-700',
      border23: 'border-purple-300/5',
      border24: 'border-purple-400/20',
      border25: 'border-purple-300',
      border26: 'border-purple-300/10',
      border27: 'border-purple-300/50',
      border28: 'border-slate-800',
      border29: 'border-purple-400/30',
      border30: 'border-purple-500/50',
      border31: 'border-slate-900',

      bg1: 'bg-purple-500/20',
      bg2: 'bg-slate-800/50',
      bg3: 'bg-slate-700/50',
      bg4: 'bg-gradient-to-br from-slate-800/90 to-slate-900/90',
      bg5: 'bg-slate-700',
      bg6: 'bg-slate-900/60',
      bg7: 'bg-gradient-to-br from-purple-500/10 via-transparent to-indigo-500/10',
      bg8: 'bg-gradient-to-br from-slate-800 to-slate-900',
      bg9: 'bg-gradient-to-br from-slate-800/80 via-slate-900/80 to-slate-800/80',
      bg10: 'bg-purple-600/10',
      bg11: 'bg-purple-300/10',
      bg12: 'bg-gray-800',
      bg13: 'bg-purple-500',
      bg14: 'bg-slate-800',
      bg15: 'bg-slate-800/60',
      bg16: 'bg-slate-900',
      bg17: 'bg-slate-700/30',
      bg18: 'bg-purple-600',
      bg19: 'bg-gray-900/40',
      bg20: 'bg-gray-900/50',
      bg21: 'bg-purple-900/30',
      bg22: 'bg-gray-700/30',
      bg23: 'bg-gray-800/40',
      bg24: 'bg-slate-900/60',
      bg25: 'bg-purple-500/10',
      bg26: 'bg-gray-700',
      bg27: 'bg-slate-800/95',
      bg28: 'bg-purple-300',
      bg29: 'bg-purple-400/60',
      bg30: 'bg-purple-400/20',
      bg31: 'bg-slate-800/40',
      bg32: 'bg-slate-800/70',
      bg33: 'bg-slate-500/20',
      bg34: 'bg-slate-900/50',
      bg35: 'bg-purple-900',
      bg36: 'bg-slate-900/30',
      bg37: 'bg-purple-800/30',
      bg38: 'bg-purple-700',
      bg39: 'bg-slate-800/90',
      bg40: 'bg-purple-400',
      bg41: 'bg-purple-600/50',
      bg42: 'bg-violet-500/10',
      bg43: 'bg-violet-400',
      bg44: 'bg-indigo-500/10',
      bg45: 'bg-slate-900/80',
      bg46: 'bg-gray-800/50',
      bg47: 'bg-slate-700/80',
      bg48: 'bg-slate-700/70',
      bg49: 'bg-violet-500',
      bg50: 'bg-purple-900/50',
      bg51: 'bg-purple-300/5',
      bg52: 'bg-purple-300/10',
      bg53: 'bg-slate-600/90',
      bg54: 'bg-purple-300/20',
      bg55: 'bg-slate-800/80',
      bg56: 'bg-purple-900/20',
      bg57: 'bg-purple-800/50',
      bg58: 'bg-purple-400/10',
      bg59: 'bg-purple-400/5',
      bg60: 'bg-slate-800/30',
      bg61: 'bg-purple-700/20',
      bg62: 'bg-purple-600/20',

      hover: 'hover:text-purple-500',
      hover1: 'hover:text-purple-300',
      hover2: 'hover:text-purple-200',
      hover3: 'hover:text-purple-400',
      hoverB: 'hover:border-purple-500/30',
      hoverB1: 'hover:border-purple-500/50',
      hoverB2: 'hover:border-purple-300/20',
      hoverB3: 'hover:border-violet-400/30',
      hoverB4: 'hover:border-purple-400',
      hoverB5: 'hover:border-purple-500',
      hoverB6: 'hover:border-purple-400/30',
      hoverB7: 'hover:border-slate-600',
      hoverB8: 'hover:border-purple-400/40',
      bgHover: 'hover:bg-slate-700/70',
      bgHover1: 'hover:bg-slate-800/60',
      bgHover2: 'hover:bg-slate-800/30',
      bgHover3: 'hover:bg-purple-600/20',
      bgHover4: 'hover:bg-purple-900/20',
      bgHover5: 'hover:bg-purple-600',
      bgHover6: 'hover:bg-purple-400',
      bgHover7: 'hover:bg-purple-500/10',
      bgHover8: 'hover:bg-purple-500/5',
      bgHover9: 'hover:bg-purple-500/40',
      bgHover10: 'hover:bg-slate-600/50',
      bgHover11: 'hover:bg-purple-700',
      bgHover12: 'hover:bg-gray-800/40',
      bgHover13: 'hover:bg-purple-500/20',
      bgHover14: 'hover:bg-slate-800',
      bgHover15: 'hover:bg-slate-700/50',
      bgHover16: 'hover:bg-slate-700/30',
      bgHover17: 'hover:bg-slate-700/80',
      bgHover18: 'hover:bg-slate-800/40',
      bgHover19: 'hover:bg-slate-700/20',
      bgHover20: 'hover:bg-slate-800/70',
      bgHover21: 'hover:bg-slate-800/80',
      bgHover22: 'hover:bg-purple-600/70',
      bgHover23: 'hover:bg-violet-600',
      bgHover24: 'hover:bg-slate-600',
      bgHover25: 'hover:bg-purple-500',
      bgHover26: 'hover:bg-purple-300/20',
      bgHover27: 'hover:bg-purple-300/30',
      bgHover28: 'hover:bg-purple-500/30',
      bgHover29: 'hover:bg-gray-700',
      bgHover30: 'hover:bg-purple-700/50',
      bgHover31: 'hover:bg-slate-700',

      textColor:
        'bg-gradient-to-r from-purple-300 via-purple-400 to-purple-300',
      textColor1: 'bg-gradient-to-br from-slate-700/50 to-slate-800/50',

      groupHover: 'group-hover:border-purple-400/60',
      groupHover1: 'group-hover:border-purple-500/30',
      groupHover3: 'group-hover:text-purple-200',
      groupHover4: 'group-hover:text-purple-200/80',
      groupHover5: 'group-hover:text-purple-200/80',
      groupHover6: 'group-hover:text-violet-200/90',
      groupHover7: 'group-hover:text-purple-300',
      groupHover8: 'group-hover:border-purple-500/50',
      groupHover9: 'group-hover:text-purple-300/60',
      groupHover10: 'group-hover:text-purple-300/80',
      groupHover11: 'group-hover:border-purple-300/50',
      groupHoverG: 'group-hover:from-purple-200',
      groupHoverG1: 'group-hover:via-indigo-200',
      groupHoverG2: 'group-hover:to-purple-200',
      groupHoverG3: 'hover:from-purple-600 hover:to-indigo-600',
      groupHoverG4: 'hover:from-violet-500/20 hover:to-indigo-500/20',
      groupHoverG5: 'hover:from-purple-500 hover:to-purple-400',
      groupHoverG6: 'hover:from-purple-400/20 hover:to-violet-400/20',
      groupHoverG7: 'hover:from-purple-400/10 hover:to-violet-400/10',
      groupHoverG8: 'hover:from-purple-500/30 hover:to-purple-400/30',
      groupHoverG9: 'hover:from-purple-300 hover:to-purple-400',
      groupHoverG10:
        'hover:from-purple-500 hover:via-purple-600 hover:to-purple-500',

      groupHoverBgr:
        'hover:bg-gradient-to-r hover:from-purple-300/5 hover:to-transparent',

      groupHoverBg: 'group-hover:bg-purple-500/20',
      groupHoverBg1: 'group-hover:bg-purple-300/20',

      focus: 'focus:border-purple-300',
      focus1: 'focus:border-purple-300/50',
      focus2: 'focus:border-purple-500/50',
      focus3: 'focus:border-purple-500',
      focus4: 'focus:border-purple-400/30',
      focus5: 'focus:border-violet-400/40',
      focus6: 'focus:border-purple-400',
      focus7: 'focus:border-purple-300/20',
      focus8: 'focus:border-purple-300/30',
      focusRing: 'focus:ring-purple-300/50',
      focusRing1: 'focus:ring-purple-500/50',
      focusRing2: 'focus:ring-purple-500',
      focusRing3: 'focus:ring-purple-500/20',
      focusRing4: 'focus:ring-violet-500/60',
      focusRing5: 'focus:ring-purple-400',
      focusRing6: 'focus:ring-purple-300/20',
      focusRing7: 'focus:ring-purple-400/30',
      focusRing8: 'focus:ring-purple-300',
      focusRing9: 'focus:ring-offset-slate-900',
      texting: 'text-slate-200',
      texting1: 'text-slate-300',
      texting2: 'text-slate-400',
      texting3: 'text-slate-900',

      bgGradient:
        'bg-gradient-to-br from-slate-900/90 via-slate-950/95 to-slate-900/90',
      bgGradient1:
        'bg-gradient-to-tr from-violet-500/10 via-transparent to-indigo-500/10',
      bgGradient2:
        'bg-[radial-gradient(circle_at_50%_50%,rgba(139,92,246,0.12),transparent_70%)]',
      bgGradient3: 'bg-violet-400/50',
      bgGradient4: 'bg-purple-400/30',
      bgGradient5: 'bg-indigo-400/20',
      bgGradient6: 'bg-gradient-to-br from-purple-900/10 to-gray-800/20',
      bgGradient7:
        'bg-gradient-to-br from-slate-800/95 via-slate-900/95 to-slate-800/95',
      bgGradient8:
        'bg-gradient-to-br from-purple-500/10 via-purple-500/10 to-slate-500/10',
      bgGradient9: 'bg-gradient-to-br from-purple-500/20 to-slate-500/20',
      bgGradient10: 'bg-gradient-to-br from-purple-500/20 to-indigo-500/20',
      bgGradient11: 'bg-gradient-to-br from-purple-500 to-purple-400',
      bgGradient12: 'bg-gradient-to-br from-slate-900/80 to-indigo-950/80',
      bgGradient13: 'bg-gradient-to-br from-slate-800/80 to-slate-900/80',
      bgGradient14: 'bg-gradient-to-r from-purple-600 to-purple-500',
      bgGradient15:
        'bg-gradient-to-br from-gray-700 via-purple-600/10 to-purple-800',
      bgGradient16:
        'bg-gradient-to-br from-purple-500/5 via-slate-900/50 to-purple-500/5',
      bgGradient17: 'bg-gradient-to-br from-purple-400/20 to-violet-400/20',
      bgGradient18: 'bg-gradient-to-br from-purple-400 to-violet-400',
      bgGradient19: 'bg-gradient-to-br from-gray-900 to-gray-800',
      bgGradient20:
        'bg-gradient-to-br from-slate-700 via-slate-800 to-slate-700',
      bgGradient21: 'bg-gradient-to-br from-purple-500 to-purple-600',
      bgGradient22:
        'bg-gradient-to-br from-purple-500/10 via-transparent to-transparent',
      bgGradient23: 'bg-gradient-to-br from-slate-700 to-slate-800',
      bgGradient24: 'bg-gradient-to-br from-slate-800/70 to-slate-900/70',
      bgGradient25:
        'bg-gradient-to-br from-teal-500/20 via-transparent to-transparent',
      bgGradient26: 'bg-gradient-to-br from-purple-500/20 to-violet-500/20',
      bgGradient27: 'bg-gradient-to-br from-slate-800/80 to-slate-950/90',
      bgGradient28: 'bg-gradient-to-br from-slate-800/60 to-slate-900/60',
      bgGradient29: 'bg-gradient-to-br from-purple-400/80 to-purple-600/80',

      bgr: 'bg-gradient-to-r from-purple-300 via-purple-200 to-indigo-200',
      bgr1: 'bg-gradient-to-r from-transparent via-violet-500/30 to-transparent',
      bgr2: 'bg-gradient-to-r from-slate-800 to-slate-900',
      bgr3: 'bg-gradient-to-r from-purple-500/10 to-slate-900/10',
      bgr4: 'bg-gradient-to-r from-purple-300 to-purple-400',
      bgr5: 'bg-gradient-to-r from-purple-300 via-purple-200 to-indigo-300',
      bgr6: 'bg-gradient-to-r from-purple-300 via-purple-200 to-purple-400',
      bgr7: 'bg-gradient-to-r from-purple-500 to-purple-400',
      bgr8: 'bg-gradient-to-r from-transparent via-violet-500/50 to-transparent',
      bgr9: 'bg-gradient-to-r from-violet-500/5 via-indigo-500/5 to-fuchsia-500/5',
      bgr10: 'bg-gradient-to-r from-violet-500/10 to-indigo-500/10',
      bgr11:
        'bg-gradient-to-r from-transparent via-indigo-500/50 to-transparent',
      bgr12: 'bg-gradient-to-r from-violet-500 to-purple-500',
      bgr13: 'bg-gradient-to-r from-violet-400 via-purple-400 to-indigo-400',
      bgr14: 'bg-gradient-to-r from-violet-500 via-purple-500 to-indigo-500',
      bgr15: 'bg-gradient-to-r from-purple-300 to-purple-500',
      bgr16: 'bg-gradient-to-r from-purple-500 to-indigo-500',
      bgr17: 'bg-gradient-to-r from-purple-500 to-violet-600',
      bgr18: 'bg-gradient-to-r from-gray-600 to-gray-700',
      bgr19: 'bg-gradient-to-r from-purple-400 to-purple-500',
      bgr20: 'bg-gradient-to-r from-purple-300/10 to-transparent',
      bgr21: 'bg-gradient-to-r from-purple-300/20 to-purple-400/20',
      bgr22: 'bg-gradient-to-r from-purple-300 to-violet-300',
      bgr23: 'bg-gradient-to-r from-purple-400/10 to-violet-400/10',
      bgr24: 'bg-gradient-to-r from-purple-400/5 to-violet-400/5',
      bgr25: 'bg-gradient-to-r from-purple-500 via-violet-500 to-purple-500',
      bgr26: 'bg-gradient-to-r from-purple-300 via-violet-300 to-purple-300',
      bgr27: 'bg-gradient-to-r from-purple-500/20 to-purple-400/20',
      bgr28: 'bg-gradient-to-r from-purple-400 to-violet-400',
      bgr29: 'bg-gradient-to-r from-slate-600 to-slate-700',
      bgr30: 'bg-gradient-to-r from-indigo-900/30 to-purple-900/30',
      bgr31: 'bg-gradient-to-r from-slate-700/50 to-slate-700/30',
      bgr32: 'bg-gradient-to-r from-purple-400 via-purple-500 to-purple-600',
      bgr33: 'bg-gradient-to-r from-purple-600/20 to-purple-500/20',
      bgr34: 'bg-gradient-to-r from-purple-900/30 to-slate-900/10',
      bgr35: 'bg-gradient-to-r from-purple-600/5 to-slate-800/5',
      bgr36: 'bg-gradient-to-r from-slate-900 to-slate-800',
      bgr37:
        'bg-gradient-to-r from-purple-500/0 via-purple-400 to-purple-500/0',
      bgr38: 'bg-gradient-to-r from-purple-400 via-purple-500 to-purple-400',
      bgr45: 'bg-gradient-to-r from-slate-800/80 to-slate-900/80',
      bgr46:
        'bg-gradient-to-r from-transparent via-purple-500/70 to-transparent',
      bgr47: 'bg-gradient-to-r from-purple-500 to-indigo-500',
      bgr48: 'bg-gradient-to-r from-purple-500/20 to-indigo-500/20',
      bgr49:
        'bg-gradient-to-r from-transparent via-purple-500/50 to-transparent',
      bgr50: 'bg-gradient-to-r from-purple-500/5 to-indigo-500/5',
      bgr51: 'bg-gradient-to-r from-purple-500/20 to-cyan-500/20',
      bgr52:
        'bg-gradient-to-r from-purple-400/30 via-purple-500/50 to-purple-400/30',
      bgr53:
        'bg-gradient-to-r from-transparent via-purple-400/40 to-transparent',
      bgr54:
        'bg-gradient-to-r from-transparent via-purple-400/20 to-transparent',
      bgr55:
        'bg-gradient-to-r from-purple-500/5 via-purple-400/30 to-purple-500/5',
      bgr56:
        'bg-gradient-to-r from-purple-500/5 via-purple-400/30 to-purple-500/5',
      bgr57: 'bg-gradient-to-r from-purple-600/20 to-purple-500/5',
      bgr58:
        'bg-gradient-to-r from-transparent via-purple-400/70 to-transparent',
      bgr59: 'bg-gradient-to-r from-purple-500/5 to-transparent',
      bgr60: 'bg-gradient-to-r from-purple-400/30 to-purple-500/30',
      bgr61: 'bg-gradient-to-r from-slate-800/50 to-slate-700/30',

      BgBottom: 'bg-gradient-to-b from-purple-400 to-indigo-500',
      BgBottom1:
        'bg-gradient-to-b from-transparent via-violet-500/50 to-transparent',
      BgBottom2:
        'bg-gradient-to-b from-transparent via-indigo-500/50 to-transparent',
      BgBottom3: 'bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900',
      BgBottom4: 'bg-gradient-to-b from-gray-800 to-gray-900',
      BgBottom5: 'bg-gradient-to-b from-purple-500/5 to-transparent',
      BgBottom6: 'bg-gradient-to-b from-slate-800 to-slate-900',
      BgBottom7:
        'bg-gradient-to-b from-transparent via-purple-500/50 to-transparent',
      BgBottom8:
        'bg-gradient-to-b from-transparent via-purple-500/30 to-transparent',
      BgBottom9:
        'bg-gradient-to-b from-transparent via-indigo-500/30 to-transparent',
      BgBottom10:
        'bg-gradient-to-b from-transparent via-purple-400/50 to-transparent',
      BgBottom11:
        'bg-gradient-to-b from-transparent via-purple-400/30 to-transparent',
      BgBottom12:
        'bg-gradient-to-b from-purple-500/5 via-purple-400/40 to-purple-500/5',

      BgTop: 'bg-gradient-to-t from-slate-900 to-transparent',

      active: 'active:text-purple-600',
      active1: 'active:bg-purple-500/40',
      placeHolder: 'placeholder-purple-300/50',
      placeHolder1: 'placeholder-purple-500/50',
      placeHolder2: 'placeholder-purple-300/30',
      placeHolder3: 'placeholder-slate-400',
      placeHolder4: 'placeholder-slate-500',
      placeHolder5: 'placeholder:text-slate-500',
      ringColor: 'ring-purple-300/50',
      ringColor1: 'ring-purple-500',
      ringColor2: 'ring-purple-400/30',
      ringColor3: 'ring-slate-800/50',
      ringColor4: 'ring-purple-300/20',
      ringColor5: 'ring-slate-900',
      divide: 'divide-slate-700/30',
      divide1: 'divide-slate-700/50',
      divide2: 'divide-purple-300/10',
      groupDisabled: 'text-purple-300/50',
      ringHover: 'hover:ring-purple-300/50',
      ringHoverG: 'group-hover:ring-purple-300/40',
      bgFocus: 'focus:bg-slate-600',
      shadow: 'shadow-slate-900/20',
      shadow1: 'shadow-slate-800/20',
      shadow2: 'shadow-slate-900/30',
      shadow3: 'shadow-purple-400/20',
      shadow4: 'shadow-purple-300/20',
      shadow5: 'shadow-purple-500/20',
      shadow6: 'shadow-slate-900/70',
      shadowhover: 'group-hover:shadow-violet-500/10',
      shadowhover1: 'hover:shadow-purple-500/20',
      shadowhover2: 'hover:shadow-purple-900/30',
      shadowhover3: 'hover:shadow-purple-500/25',
      shadowhover4: 'hover:shadow-violet-500/10',
      shadowhover5: 'hover:shadow-violet-900/10',
      shadowhover6: 'hover:shadow-purple-300/10',
      shadowhover7: 'hover:shadow-purple-500/60',
      shadowhover8: 'hover:shadow-slate-500/20',
      shadowhover9: 'hover:shadow-purple-500/40',
      shadowhover10: 'shadow-purple-500/10',
      shadowhover11: 'hover:shadow-purple-500/40',

      shadowing: 'shadow-purple-500/30',
      shadowing1: 'shadow-violet-500/20',
      shadowing2: 'shadow-purple-500/40',

      // Extra Bg Color
      bgEx: 'bg-fuchsia-400/5'
    },
    mui: {
      main: '#A78BFA',
      hover: '#8B5CF6',
      active: '#7C3AED',
      border: '#A78BFA',
      border1: 'rgba(167, 139, 250, 0.2)',
      fill: 'rgba(167, 139, 250, 0.1)',
      cart: '#475569',
      light: '#C4B5FD',
      bg2: 'rgba(26, 31, 46, 0.8), rgba(26, 31, 46, 0.8)',

      // Excel Export Expenses
      bge1: '#1E293B',
      main1: '#8B5CF6',
      shadowE: 'rgba(139, 92, 246, 0.3)',
      shadowE1: 'rgba(139, 92, 246, 0.7)',
      shadowE2: '0 0 15px rgba(192, 132, 252, 0.5)',
      shadowE3: '0 0 8px 2px rgba(153, 0, 255, 0.4)',
      shadowE4:
        '0 0 40px rgba(0, 0, 0, 0.5), inset 0 0 2px rgba(153, 0, 255, 0.3)',
      // Salary History
      BgLinear: 'linear-gradient(to bottom right, #1e293b, #0f172a, #1e293b)',
      BgLinear1:
        'linear-gradient(90deg, transparent, rgba(168, 85, 247, 0.1), transparent)',

      // Approve scholarship
      bgA: '#7C3AED',

      // custom scroll bar:
      bgCB: 'rgba(192, 132, 252, 0.3)',
      bgCB1: 'rgba(192, 132, 252, 0.5)'
    }
  },
  {
    tailwind: {
      // Light theme - white, gray, and subtle accent colors
      text: 'text-gray-800',
      text1: 'text-gray-600',
      text2: 'text-gray-500',
      text3: 'text-gray-900',
      text4: 'text-gray-700',
      text5: 'bg-gradient-to-r from-gray-700 to-gray-800',
      text6: 'bg-gradient-to-r from-gray-600 to-gray-700',
      text7: 'text-gray-400',
      text8: 'bg-gradient-to-r from-gray-700 to-gray-900',
      text9: 'text-gray-700',
      text10: 'text-gray-800',
      text11: 'text-gray-700',
      text12: 'text-gray-600',
      text13: 'text-gray-900',
      text14: 'text-gray-800',
      text15: 'text-blue-600',
      text16: 'text-indigo-600',
      text17: 'text-gray-600',
      text18: 'text-gray-500',
      text19: 'text-gray-600',
      text20: 'text-gray-600',
      text21: 'text-gray-500',
      text22: 'text-gray-800',
      text23: 'text-gray-700',

      border: 'border-gray-300',
      border1: 'border-gray-200',
      border2: 'border-gray-300',
      border3: 'border-gray-200',
      border4: 'border-gray-300',
      border5: 'border-gray-400',
      border6: 'border-gray-400',
      border7: 'border-gray-500',
      border8: 'border-gray-400',
      border9: 'border-gray-500',
      border10: 'border-gray-300',
      border11: 'border-gray-300',
      border12: 'border-gray-200',
      border13: 'border-gray-300',
      border14: 'border-gray-200',
      border15: 'border-gray-300',
      border16: 'border-gray-300',
      border17: 'border-gray-400',
      border18: 'border-gray-200',
      border19: 'border-gray-300',
      border20: 'border-blue-200',
      border21: 'border-gray-400',
      border22: 'border-gray-300',
      border23: 'border-gray-100',
      border24: 'border-gray-200',
      border25: 'border-gray-300',
      border26: 'border-gray-200',
      border27: 'border-gray-300',
      border28: 'border-gray-400',
      border29: 'border-gray-200',
      border30: 'border-gray-300',
      border31: 'border-gray-300',

      bg1: 'bg-gray-100',
      bg2: 'bg-white',
      bg3: 'bg-gray-50',
      bg4: 'bg-gradient-to-br from-white to-gray-50',
      bg5: 'bg-gray-100',
      bg6: 'bg-white',
      bg7: 'bg-gradient-to-br from-blue-50 via-transparent to-indigo-50',
      bg8: 'bg-gradient-to-br from-white to-gray-50',
      bg9: 'bg-gradient-to-br from-gray-50 to-white',
      bg10: 'bg-gray-100',
      bg11: 'bg-gray-50',
      bg12: 'bg-gray-100',
      bg13: 'bg-gray-700',
      bg14: 'bg-white',
      bg15: 'bg-gray-50',
      bg16: 'bg-white',
      bg17: 'bg-gray-50',
      bg18: 'bg-gray-700',
      bg19: 'bg-gray-100',
      bg20: 'bg-gray-50',
      bg21: 'bg-blue-50',
      bg22: 'bg-gray-100',
      bg23: 'bg-gray-50',
      bg24: 'bg-white',
      bg25: 'bg-gray-50',
      bg26: 'bg-gray-100',
      bg27: 'bg-white',
      bg28: 'bg-gray-200',
      bg29: 'bg-gray-300',
      bg30: 'bg-gray-100',
      bg31: 'bg-gray-50',
      bg32: 'bg-white',
      bg33: 'bg-gray-100',
      bg34: 'bg-gray-50',
      bg35: 'bg-gray-800',
      bg36: 'bg-gray-50',
      bg37: 'bg-blue-50',
      bg38: 'bg-gray-600',
      bg39: 'bg-white',
      bg40: 'bg-gray-300',
      bg41: 'bg-gray-200',
      bg42: 'bg-blue-50',
      bg43: 'bg-blue-600',
      bg44: 'bg-indigo-50',
      bg45: 'bg-white',
      bg46: 'bg-gray-50',
      bg47: 'bg-gray-100',
      bg48: 'bg-gray-100',
      bg49: 'bg-blue-600',
      bg50: 'bg-blue-100',
      bg51: 'bg-gray-50',
      bg52: 'bg-gray-50',
      bg53: 'bg-gray-200',
      bg54: 'bg-gray-100',
      bg55: 'bg-white',
      bg56: 'bg-blue-50',
      bg57: 'bg-blue-100',
      bg58: 'bg-gray-50',
      bg59: 'bg-gray-50',
      bg60: 'bg-gray-50',
      bg61: 'bg-blue-50',
      bg62: 'bg-blue-50',
      bg63: 'bg-gray-50',
      bg64: 'bg-blue-50',

      hover: 'hover:text-gray-900',
      hover1: 'hover:text-gray-700',
      hover2: 'hover:text-gray-600',
      hover3: 'hover:text-gray-800',
      hoverB: 'hover:border-gray-400',
      hoverB1: 'hover:border-gray-400',
      hoverB2: 'hover:border-gray-300',
      hoverB3: 'hover:border-blue-400',
      hoverB4: 'hover:border-gray-400',
      hoverB5: 'hover:border-gray-500',
      hoverB6: 'hover:border-gray-400',
      hoverB7: 'hover:border-gray-400',
      hoverB8: 'hover:border-gray-400',
      bgHover: 'hover:bg-gray-100',
      bgHover1: 'hover:bg-gray-50',
      bgHover2: 'hover:bg-gray-50',
      bgHover3: 'hover:bg-gray-100',
      bgHover4: 'hover:bg-blue-50',
      bgHover5: 'hover:bg-gray-700',
      bgHover6: 'hover:bg-gray-300',
      bgHover7: 'hover:bg-gray-50',
      bgHover8: 'hover:bg-gray-50',
      bgHover9: 'hover:bg-gray-200',
      bgHover10: 'hover:bg-gray-100',
      bgHover11: 'hover:bg-gray-600',
      bgHover12: 'hover:bg-gray-100',
      bgHover13: 'hover:bg-gray-100',
      bgHover14: 'hover:bg-white',
      bgHover15: 'hover:bg-gray-100',
      bgHover16: 'hover:bg-gray-50',
      bgHover17: 'hover:bg-gray-100',
      bgHover18: 'hover:bg-gray-50',
      bgHover19: 'hover:bg-gray-50',
      bgHover20: 'hover:bg-white',
      bgHover21: 'hover:bg-white',
      bgHover22: 'hover:bg-gray-700',
      bgHover23: 'hover:bg-blue-700',
      bgHover24: 'hover:bg-gray-200',
      bgHover25: 'hover:bg-gray-700',
      bgHover26: 'hover:bg-gray-100',
      bgHover27: 'hover:bg-gray-100',
      bgHover28: 'hover:bg-gray-200',
      bgHover29: 'hover:bg-gray-200',
      bgHover30: 'hover:bg-blue-100',
      bgHover31: 'hover:bg-gray-100',

      textColor: 'bg-gradient-to-r from-gray-700 via-gray-800 to-gray-700',
      textColor1: 'bg-gradient-to-br from-gray-100 to-gray-200',

      groupHover: 'group-hover:border-gray-400',
      groupHover1: 'group-hover:border-gray-400',
      groupHover3: 'group-hover:text-gray-700',
      groupHover4: 'group-hover:text-gray-700',
      groupHover5: 'group-hover:text-gray-700',
      groupHover6: 'group-hover:text-blue-700',
      groupHover7: 'group-hover:text-gray-700',
      groupHover8: 'group-hover:border-gray-400',
      groupHover9: 'group-hover:text-gray-600',
      groupHover10: 'group-hover:text-gray-700',
      groupHover11: 'group-hover:border-gray-300',
      groupHover12: 'group-hover:text-gray-800',
      groupHoverG: 'group-hover:from-gray-600',
      groupHoverG1: 'group-hover:via-gray-700',
      groupHoverG2: 'group-hover:to-gray-600',
      groupHoverG3: 'hover:from-gray-700 hover:to-gray-900',
      groupHoverG4: 'hover:from-blue-100 hover:to-indigo-100',
      groupHoverG5: 'hover:from-gray-700 hover:to-gray-600',
      groupHoverG6: 'hover:from-gray-100 hover:to-blue-100',
      groupHoverG7: 'hover:from-gray-50 hover:to-blue-50',
      groupHoverG8: 'hover:from-gray-200 hover:to-gray-100',
      groupHoverG9: 'hover:from-gray-700 hover:to-gray-800',
      groupHoverG10: 'hover:from-gray-700 hover:via-gray-800 hover:to-gray-700',
      groupHoverG11: 'hover:from-gray-800 hover:to-blue-800',

      groupHoverBgr:
        'hover:bg-gradient-to-r hover:from-gray-100 hover:to-transparent',

      groupHoverBg: 'group-hover:bg-gray-100',
      groupHoverBg1: 'group-hover:bg-gray-100',
      groupHoverBg2: 'group-hover:bg-white',

      focus: 'focus:border-gray-400',
      focus1: 'focus:border-gray-300',
      focus2: 'focus:border-gray-400',
      focus3: 'focus:border-gray-500',
      focus4: 'focus:border-gray-300',
      focus5: 'focus:border-blue-400',
      focus6: 'focus:border-gray-400',
      focus7: 'focus:border-gray-300',
      focus8: 'focus:border-gray-300',
      focusRing: 'focus:ring-gray-300',
      focusRing1: 'focus:ring-gray-400',
      focusRing2: 'focus:ring-gray-500',
      focusRing3: 'focus:ring-gray-300',
      focusRing4: 'focus:ring-blue-400',
      focusRing5: 'focus:ring-gray-400',
      focusRing6: 'focus:ring-gray-300',
      focusRing7: 'focus:ring-gray-300',
      focusRing8: 'focus:ring-gray-300',
      focusRing9: 'focus:ring-offset-white',
      texting: 'text-gray-700',
      texting1: 'text-gray-600',
      texting2: 'text-gray-500',
      texting3: 'text-white',

      bgGradient: 'bg-gradient-to-br from-white via-gray-50 to-white',
      bgGradient1:
        'bg-gradient-to-tr from-blue-50 via-transparent to-indigo-50',
      bgGradient2:
        'bg-[radial-gradient(circle_at_50%_50%,rgba(59,130,246,0.08),transparent_70%)]',
      bgGradient3: 'bg-blue-100',
      bgGradient4: 'bg-gray-100',
      bgGradient5: 'bg-indigo-50',
      bgGradient6: 'bg-gradient-to-br from-blue-50 to-gray-100',
      bgGradient7: 'bg-gradient-to-br from-white to-gray-50',
      bgGradient8: 'bg-gradient-to-br from-gray-50 to-gray-100',
      bgGradient9: 'bg-gradient-to-br from-gray-100 to-gray-50',
      bgGradient10: 'bg-gradient-to-br from-gray-100 to-indigo-100',
      bgGradient11: 'bg-gradient-to-br from-gray-700 to-gray-600',
      bgGradient12: 'bg-gradient-to-br from-white to-indigo-50',
      bgGradient13: 'bg-gradient-to-br from-gray-50 to-white',
      bgGradient14: 'bg-gradient-to-r from-gray-700 to-gray-600',
      bgGradient15: 'bg-gradient-to-br from-gray-100 via-blue-50 to-blue-100',
      bgGradient16: 'bg-gradient-to-br from-gray-50 via-white to-gray-50',
      bgGradient17: 'bg-gradient-to-br from-gray-100 to-blue-100',
      bgGradient18: 'bg-gradient-to-br from-gray-300 to-blue-300',
      bgGradient19: 'bg-gradient-to-br from-gray-100 to-gray-50',
      bgGradient20: 'bg-gradient-to-br from-gray-100 via-white to-gray-100',
      bgGradient21: 'bg-gradient-to-br from-gray-700 to-gray-800',
      bgGradient22:
        'bg-gradient-to-br from-gray-100 via-transparent to-transparent',
      bgGradient23: 'bg-gradient-to-br from-gray-100 to-white',
      bgGradient24: 'bg-gradient-to-br from-gray-50 to-gray-100',
      bgGradient25:
        'bg-gradient-to-br from-gray-100 via-transparent to-transparent',
      bgGradient26: 'bg-gradient-to-br from-gray-100 to-blue-100',
      bgGradient27: 'bg-gradient-to-br from-gray-50 to-white',
      bgGradient28: 'bg-gradient-to-br from-gray-50 to-gray-100',
      bgGradient29: 'bg-gradient-to-br from-gray-300 to-gray-400',

      // Horizontal gradients (bgr)
      bgr: 'bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200',
      bgr1: 'bg-gradient-to-r from-transparent via-blue-100 to-transparent',
      bgr2: 'bg-gradient-to-r from-gray-100 to-white',
      bgr3: 'bg-gradient-to-r from-gray-100 to-white',
      bgr4: 'bg-gradient-to-r from-gray-200 to-gray-300',
      bgr5: 'bg-gradient-to-r from-gray-200 via-gray-100 to-indigo-200',
      bgr6: 'bg-gradient-to-r from-gray-200 via-gray-100 to-gray-300',
      bgr7: 'bg-gradient-to-r from-gray-700 to-gray-600',
      bgr8: 'bg-gradient-to-r from-transparent via-blue-200 to-transparent',
      bgr9: 'bg-gradient-to-r from-blue-50 via-indigo-50 to-purple-50',
      bgr10: 'bg-gradient-to-r from-blue-100 to-indigo-100',
      bgr11: 'bg-gradient-to-r from-transparent via-indigo-100 to-transparent',
      bgr12: 'bg-gradient-to-r from-blue-600 to-gray-700',
      bgr13: 'bg-gradient-to-r from-blue-300 via-gray-300 to-indigo-300',
      bgr14: 'bg-gradient-to-r from-blue-600 via-gray-600 to-indigo-600',
      bgr15: 'bg-gradient-to-r from-gray-200 to-gray-400',
      bgr16: 'bg-gradient-to-r from-gray-600 to-indigo-600',
      bgr17: 'bg-gradient-to-r from-gray-600 to-blue-700',
      bgr18: 'bg-gradient-to-r from-gray-300 to-gray-400',
      bgr19: 'bg-gradient-to-r from-gray-300 to-gray-400',
      bgr20: 'bg-gradient-to-r from-gray-100 to-transparent',
      bgr21: 'bg-gradient-to-r from-gray-200 to-gray-300',
      bgr22: 'bg-gradient-to-r from-gray-200 to-blue-200',
      bgr23: 'bg-gradient-to-r from-gray-100 to-blue-100',
      bgr24: 'bg-gradient-to-r from-gray-50 to-blue-50',
      bgr25: 'bg-gradient-to-r from-gray-600 via-blue-600 to-gray-600',
      bgr26: 'bg-gradient-to-r from-gray-200 via-blue-200 to-gray-200',
      bgr27: 'bg-gradient-to-r from-gray-200 to-gray-100',
      bgr28: 'bg-gradient-to-r from-gray-300 to-blue-300',
      bgr29: 'bg-gradient-to-r from-gray-300 to-gray-400',
      bgr30: 'bg-gradient-to-r from-indigo-100 to-blue-100',
      bgr31: 'bg-gradient-to-r from-gray-100 to-gray-50',
      bgr32: 'bg-gradient-to-r from-gray-300 via-gray-400 to-gray-500',
      bgr33: 'bg-gradient-to-r from-gray-300 to-gray-200',
      bgr34: 'bg-gradient-to-r from-blue-100 to-gray-50',
      bgr35: 'bg-gradient-to-r from-gray-100 to-white',
      bgr36: 'bg-gradient-to-r from-white to-gray-100',
      bgr37: 'bg-gradient-to-r from-gray-100/0 via-gray-300 to-gray-100/0',
      bgr38: 'bg-gradient-to-r from-gray-300 via-gray-400 to-gray-300',
      bgr39: 'bg-gradient-to-r from-white via-indigo-50 to-blue-50',
      bgr40: 'bg-gradient-to-r from-gray-600 to-indigo-600',
      bgr41: 'bg-gradient-to-r from-gray-300 to-indigo-500',
      bgr42: 'bg-gradient-to-r from-gray-200 via-indigo-200 to-purple-200',
      bgr43:
        'bg-gradient-to-r from-gray-200 to-indigo-200 border border-gray-300',
      bgr44: 'bg-gradient-to-r from-gray-100 to-blue-100',
      bgr45: 'bg-gradient-to-r from-white to-gray-50',
      bgr46: 'bg-gradient-to-r from-transparent via-gray-400 to-transparent',
      bgr47: 'bg-gradient-to-r from-gray-600 to-blue-600',
      bgr48: 'bg-gradient-to-r from-gray-200 to-blue-200',
      bgr49: 'bg-gradient-to-r from-transparent via-gray-300 to-transparent',
      bgr50: 'bg-gradient-to-r from-gray-50 to-blue-50',
      bgr51: 'bg-gradient-to-r from-gray-200 to-blue-200',
      bgr52: 'bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200',
      bgr53: 'bg-gradient-to-r from-transparent via-gray-300 to-transparent',
      bgr54: 'bg-gradient-to-r from-transparent via-gray-200 to-transparent',
      bgr55: 'bg-gradient-to-r from-gray-100 via-gray-300 to-gray-100',
      bgr56: 'bg-gradient-to-r from-gray-100 via-gray-300 to-gray-100',
      bgr57: 'bg-gradient-to-r from-gray-300 to-gray-100',
      bgr58: 'bg-gradient-to-r from-transparent via-gray-400 to-transparent',
      bgr59: 'bg-gradient-to-r from-gray-100 to-transparent',
      bgr60: 'bg-gradient-to-r from-gray-200 to-gray-300',
      bgr61: 'bg-gradient-to-r from-white to-gray-50',

      // Vertical gradients (BgBottom)
      BgBottom: 'bg-gradient-to-b from-gray-300 to-blue-400',
      BgBottom1:
        'bg-gradient-to-b from-transparent via-blue-100 to-transparent',
      BgBottom2:
        'bg-gradient-to-b from-transparent via-indigo-100 to-transparent',
      BgBottom3: 'bg-gradient-to-b from-white via-gray-100 to-white',
      BgBottom4: 'bg-gradient-to-b from-gray-100 to-gray-50',
      BgBottom5: 'bg-gradient-to-b from-gray-100 to-transparent',
      BgBottom6: 'bg-gradient-to-b from-gray-100 to-white',
      BgBottom7:
        'bg-gradient-to-b from-transparent via-gray-300 to-transparent',
      BgBottom8:
        'bg-gradient-to-b from-transparent via-gray-200 to-transparent',
      BgBottom9:
        'bg-gradient-to-b from-transparent via-blue-100 to-transparent',
      BgBottom10:
        'bg-gradient-to-b from-transparent via-gray-300 to-transparent',
      BgBottom11:
        'bg-gradient-to-b from-transparent via-gray-200 to-transparent',
      BgBottom12: 'bg-gradient-to-b from-gray-100 via-gray-300 to-gray-100',

      // Top gradient
      BgTop: 'bg-gradient-to-t from-white to-transparent',

      // Top-left gradient
      BgTopLeft:
        'bg-gradient-to-tl from-gray-50 via-transparent to-transparent',

      active: 'active:text-gray-900',
      active1: 'active:bg-gray-200',
      placeHolder: 'placeholder-gray-400',
      placeHolder1: 'placeholder-gray-400',
      placeHolder2: 'placeholder-gray-300',
      placeHolder3: 'placeholder-gray-500',
      placeHolder4: 'placeholder-gray-400',
      placeHolder5: 'placeholder:text-gray-400',
      ringColor: 'ring-gray-300',
      ringColor1: 'ring-gray-400',
      ringColor2: 'ring-gray-300',
      ringColor3: 'ring-gray-200',
      ringColor4: 'ring-gray-200',
      ringColor5: 'ring-white',
      ringColor6: 'ring-gray-400',
      divide: 'divide-gray-200',
      divide1: 'divide-gray-300',
      divide2: 'divide-gray-200',
      groupDisabled: 'text-gray-400',
      ringHover: 'hover:ring-gray-300',
      ringHoverG: 'group-hover:ring-gray-300',
      bgFocus: 'focus:bg-gray-200',
      shadow: 'shadow-gray-200',
      shadow1: 'shadow-gray-300',
      shadow2: 'shadow-gray-300',
      shadow3: 'shadow-blue-200',
      shadow4: 'shadow-gray-200',
      shadow5: 'shadow-gray-300',
      shadow6: 'shadow-gray-400',
      shadowhover: 'group-hover:shadow-blue-200',
      shadowhover1: 'hover:shadow-gray-300',
      shadowhover2: 'hover:shadow-blue-200',
      shadowhover3: 'hover:shadow-gray-300',
      shadowhover4: 'hover:shadow-blue-100',
      shadowhover5: 'hover:shadow-blue-100',
      shadowhover6: 'hover:shadow-gray-200',
      shadowhover7: 'hover:shadow-gray-400',
      shadowhover8: 'hover:shadow-gray-200',
      shadowhover9: 'hover:shadow-blue-300',
      shadowhover10: 'shadow-gray-200',
      shadowhover11: 'hover:shadow-gray-300',

      shadowing: 'shadow-gray-300',
      shadowing1: 'shadow-blue-200',
      shadowing2: 'shadow-gray-300',

      bgEx: 'bg-purple-50',
      bgEx1: 'bg-blue-50'
    },
    mui: {
      main: '#6B7280',
      hover: '#4B5563',
      active: '#374151',
      border: '#D1D5DB',
      border1: 'rgba(209, 213, 219, 0.5)',
      fill: 'rgba(107, 114, 128, 0.1)',
      cart: '#F3F4F6',
      light: '#9CA3AF',
      bg2: 'rgba(255, 255, 255, 0.8), rgba(249, 250, 251, 0.8)',

      bge1: '#F9FAFB',
      main1: '#4B5563',
      shadowE: 'rgba(107, 114, 128, 0.2)',
      shadowE1: 'rgba(107, 114, 128, 0.4)',
      shadowE2: '0 0 15px rgba(156, 163, 175, 0.3)',
      shadowE3: '0 0 8px 2px rgba(156, 163, 175, 0.2)',
      shadowE4:
        '0 0 40px rgba(0, 0, 0, 0.1), inset 0 0 2px rgba(156, 163, 175, 0.2)',

      BgLinear: 'linear-gradient(to bottom right, #ffffff, #f9fafb, #ffffff)',
      BgLinear1:
        'linear-gradient(90deg, transparent, rgba(107, 114, 128, 0.05), transparent)',

      bgA: '#4B5563',

      mainC: '#9CA3AF',
      mainC1: '#3B82F6',
      bgC: '#F3F4F6',

      bgCB: 'rgba(156, 163, 175, 0.3)',
      bgCB1: 'rgba(156, 163, 175, 0.5)'
    }
  }
]

const defaultGradient = gradientBackgrounds[0]

export const MyProSidebarProvider = ({ children }) => {
  const { societies } = useSelector(state => state.societies)
  const { activeUser } = useSelector(state => state.auth)

  const [activeSociety, setActiveSocietyState] = useState(() => {
    const saved = localStorage.getItem(ACTIVE_SOCIETY_KEY)
    return saved ? JSON.parse(saved) : null
  })
  const [themeMode, setThemeMode] = useState(() => {
    const saved = localStorage.getItem('themeMode')
    return saved || 'dark'
  })

  // Initially collapse sidebar on smaller screens
  const [collapsed, setCollapsed] = useState(() => {
    return window.innerWidth < 1024
  })

  // State to track if sidebar is visible on mobile (as overlay)
  const [mobileOpen, setMobileOpen] = useState(false)

  const savedSociety = useMemo(() => {
    const saved = localStorage.getItem(ACTIVE_SOCIETY_KEY)
    return saved ? JSON.parse(saved) : null
  }, [])

  // Create a mapping of society IDs to background gradients and theme colors
  const societySettingsMap = useMemo(() => {
    const map = new Map()
    if (societies) {
      societies.forEach((society, index) => {
        map.set(society._id, {
          gradient: gradientBackgrounds[index % gradientBackgrounds.length],
          theme: themeColors[index % themeColors.length]
        })
      })
    }
    return map
  }, [societies])

  useEffect(() => {
    const handleThemeChange = event => {
      setThemeMode(event.detail.mode)
    }

    window.addEventListener('themeChange', handleThemeChange)
    return () => window.removeEventListener('themeChange', handleThemeChange)
  }, [])

  useEffect(() => {
    if (!societies?.length) return

    const initializeSociety = () => {
      // If we have a saved society, verify it still exists in the current societies list
      if (savedSociety) {
        const societyStillExists = societies.find(
          s => s._id === savedSociety._id
        )
        if (societyStillExists) {
          // Check if the society data has been updated (e.g., plot prices changed)
          const updatedSociety = societies.find(s => s._id === savedSociety._id)
          if (
            updatedSociety &&
            JSON.stringify(updatedSociety) !== JSON.stringify(savedSociety)
          ) {
            // Society data has been updated, use the fresh data
            setActiveSocietyState(updatedSociety)
            localStorage.setItem(
              ACTIVE_SOCIETY_KEY,
              JSON.stringify(updatedSociety)
            )
            return
          }
          setActiveSocietyState(savedSociety)
          return
        }
      }

      // If no valid saved society, set based on user role
      if (activeUser?.role === 'Employee') {
        // For employees, find their first assigned society
        const employeeSociety = societies.find(society =>
          activeUser.societies?.some(
            userSociety => userSociety._id === society._id
          )
        )
        if (employeeSociety) {
          setActiveSocietyState(employeeSociety)
          localStorage.setItem(
            ACTIVE_SOCIETY_KEY,
            JSON.stringify(employeeSociety)
          )
        }
      } else {
        // For admins or other roles, default to first society
        setActiveSocietyState(societies[0])
        localStorage.setItem(ACTIVE_SOCIETY_KEY, JSON.stringify(societies[0]))
      }
    }

    initializeSociety()

    // Add event listener to handle window resize
    const handleResize = () => {
      const isMediumOrSmaller = window.innerWidth < 1024
      if (!isMediumOrSmaller && mobileOpen) {
        // If screen size increases and mobile sidebar is open, close it
        setMobileOpen(false)
      }
      setCollapsed(isMediumOrSmaller)
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [societies, activeUser, savedSociety, mobileOpen])

  const updateActiveSociety = society => {
    if (society) {
      setActiveSocietyState(society)
      localStorage.setItem(ACTIVE_SOCIETY_KEY, JSON.stringify(society))
    }
  }

  // Toggle sidebar for both desktop and mobile
  // Update the toggleSidebar function in MyProSidebarProvider
  const toggleSidebar = () => {
    const isMediumOrSmaller = window.innerWidth < 1024

    if (isMediumOrSmaller) {
      setMobileOpen(prev => !prev)
      setCollapsed(false)
    } else {
      setCollapsed(prev => !prev)
    }
  }
  // Determine the gradient and theme for the active society
  // const societySettings = useMemo(() => {
  //   if (!activeSociety)
  //     return { gradient: defaultGradient, theme: themeColors[0] }
  //   return (
  //     societySettingsMap.get(activeSociety._id) || {
  //       gradient: defaultGradient,
  //       theme: themeColors[0]
  //     }
  //   )
  // }, [activeSociety, societySettingsMap])

  const societySettings = useMemo(() => {
    if (!activeSociety)
      return { gradient: defaultGradient, theme: themeColors[0] }

    const baseSettings = societySettingsMap.get(activeSociety._id) || {
      gradient: defaultGradient,
      theme: themeColors[0]
    }

    // Switch to light theme (index 3) when themeMode is 'light'
    if (themeMode === 'light') {
      return {
        gradient: 'bg-gradient-to-br from-white via-gray-50 to-white',
        theme: themeColors[3] // Light theme
      }
    }

    return baseSettings
  }, [activeSociety, societySettingsMap, themeMode])

  const contextValue = useMemo(
    () => ({
      activeSociety,
      setActiveSociety: updateActiveSociety,

      gradient: societySettings.gradient,
      theme: societySettings.theme,
      collapsed,
      setCollapsed,
      mobileOpen,
      setMobileOpen,
      toggleSidebar,
      themeMode
    }),
    [activeSociety, societySettings, collapsed, mobileOpen, themeMode]
  )

  return (
    <ProSidebarProvider>
      <SidebarContext.Provider value={contextValue}>
        <div className={`flex h-screen ${societySettings.gradient}`}>
          <div className='relative flex flex-grow'>
            {mobileOpen && (
              <div
                className='fixed inset-0 bg-black bg-opacity-50 z-[55]'
                onClick={toggleSidebar}
              />
            )}

            <div
              className={`fixed inset-y-0 left-0 z-[60] transition-transform duration-300 transform lg:relative lg:translate-x-0 ${
                mobileOpen
                  ? 'translate-x-0'
                  : '-translate-x-full lg:translate-x-0'
              }`}
            >
              <FuturisticRealEstateSidebar />
            </div>

            <div className='flex-grow'>{children}</div>
          </div>
        </div>
      </SidebarContext.Provider>
    </ProSidebarProvider>
  )
}

export const useSidebarContext = () => {
  const context = useContext(SidebarContext)
  if (!context) {
    throw new Error(
      'useSidebarContext must be used within MyProSidebarProvider'
    )
  }
  return context
}

export default MyProSidebarProvider
